import { NULL } from "node-sass";
import React from "react";
import activeIcon from "../src/assets/activeIcon.svg";
import archiveIcon from "../src/assets/archiveIcon.svg";
import allIcon from "../src/assets/IconAll.svg";

export const STATUS = {
  ERROR: "ERROR",
  SUCCESS: "SUCCESS",
  LOADING: "LOADING",
  CLEAR: "CLEAR",
  FAILURE: "FAILURE"
};

export const LOGIN_ACTION = {
  LOGIN_START: "LOGIN_START",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_FAILURE: "LOGIN_FAILURE",
  LOGIN_CLEAR: "LOGIN_CLEAR",
  KEYCLOAK_LOGIN_START: "KEYCLOAK_LOGIN_START",
  KEYCLOAK_LOGIN_SUCCESS: "KEYCLOAK_LOGIN_SUCCESS",
  KEYCLOAK_LOGIN_FAILURE: "KEYCLOAK_LOGIN_FAILURE",
  KEYCLOAK_LOGIN_CLEAR: "KEYCLOAK_LOGIN_CLEAR",
  OTP_START: "OTP_START",
  OTP_SUCCESS: "OTP_SUCCESS",
  OTP_FAILURE: "OTP_FAILURE",
  OTP_MSG_CLEAR: "OTP_MSG_CLEAR",
  LOGOUT_START: "LOGOUT_START",
  LOGOUT_SUCCESS: "LOGOUT_SUCCESS",
  LOGOUT_FAILURE: "LOGOUT_FAILURE",
  SECURITY_START: "SECURITY_START",
  SECURITY_SUCCESS: "SECURITY_SUCCESS",
  SECURITY_FAILURE: "SECURITY_FAILURE",
  LOGIN_REQUEST_START: "LOGIN_REQUEST_START",
  LOGIN_REQUEST_SUCCESS: "LOGIN_REQUEST_SUCCESS",
  LOGIN_REQUEST_FAILURE: "LOGIN_REQUEST_FAILURE"
};

export const MOM_ACTION = {
  MOM_CREATE_START: "MOM_CREATE_START",
  MOM_CREATE_SUCCESS: "MOM_CREATE_SUCCESS",
  MOM_CREATE_FAILURE: "MOM_CREATE_FAILURE",
  MOM_DETAILS_START: "MOM_DETAILS_START",
  MOM_DETAILS_SUCCESS: "MOM_DETAILS_SUCCESS",
  MOM_DETAILS_FAILURE: "MOM_DETAILS_FAILURE",
  MOM_DETAILS_CLEAR: "MOM_DETAILS_CLEAR",
  GET_MOMS_START: "GET_MOMS_START",
  GET_MOMS_SUCCESS: "GET_MOMS_SUCCESS",
  GET_MOMS_FAILURE: "GET_MOMS_FAILURE",
  UPDATE_MOM_START: "UPDATE_MOM_START",
  UPDATE_MOM_SUCCESS: "UPDATE_MOM_SUCCESS",
  UPDATE_MOM_FAILURE: "UPDATE_MOM_FAILURE",
  ADD_DECISION_START: "ADD_DECISION_START",
  ADD_DECISION_SUCCESS: "ADD_DECISION_SUCCESS",
  ADD_DECISION_FAILURE: "ADD_DECISION_FAILURE",
  SEND_MEETING_REMINDER_START: "SEND_MEETING_REMINDER_START",
  SEND_MEETING_REMINDER_SUCCESS: "SEND_MEETING_REMINDER_SUCCESS",
  SEND_MEETING_REMINDER_FAILURE: "SEND_MEETING_REMINDER_FAILURE",
  GET_AGENDA_SUMMARY_START: "GET_AGENDA_SUMMARY_START",
  GET_AGENDA_SUMMARY_SUCCESS: "GET_AGENDA_SUMMARY_SUCCESS",
  GET_AGENDA_SUMMARY_FAILURE: "GET_AGENDA_SUMMARY_FAILURE"
};

export const FORGET_ACTION = {
  FORGET_START: "FORGET_START",
  FORGET_SUCCESS: "FORGET_SUCCESS",
  FORGET_FAILURE: "FORGET_FAILURE"
};

export const TABLE_CONFIG = {
  ROWS: 50
};

export const COMMON_ACTION = {
  TOGGLE_SIDEBAR: "TOGGLE_SIDEBAR",
  IMAGE_UPLOADING_START: "IMAGE_UPLOADING_START",
  IMAGE_UPLOADING_SUCCESS: "IMAGE_UPLOADING_SUCCESS",
  IMAGE_UPLOADING_FAILURE: "IMAGE_UPLOADING_FAILURE",
  DELETE_IMAGE_UPLOADING_START: "DELETE_IMAGE_UPLOADING_START",
  DELETE_IMAGE_UPLOADING_SUCCESS: "DELETE_IMAGE_UPLOADING_SUCCESS",
  DELETE_IMAGE_UPLOADING_FAILURE: "DELETE_IMAGE_UPLOADING_FAILURE",
  GET_ISSUES_CATEGORY_LIST_START: "GET_ISSUES_CATEGORY_LIST_START",
  GET_ISSUES_CATEGORY_LIST_SUCCESS: "GET_ISSUES_CATEGORY_LIST_SUCCESS",
  GET_ISSUES_CATEGORY_LIST_FAILURE: "GET_ISSUES_CATEGORY_LIST_FAILURE",
  GET_ISSUES_SUB_CATEGORY_LIST_START: "GET_ISSUES_SUB_CATEGORY_LIST_START",
  GET_ISSUES_SUB_CATEGORY_LIST_SUCCESS: "GET_ISSUES_SUB_CATEGORY_LIST_SUCCESS",
  GET_ISSUES_SUB_CATEGORY_LIST_FAILURE: "GET_ISSUES_SUB_CATEGORY_LIST_FAILURE",
  ISSUE_LIST_START: "ISSUE_LIST_START",
  ISSUE_LIST_SUCCESS: "ISSUE_LIST_SUCCESS",
  ISSUE_LIST_FAILURE: "ISSUE_LIST_FAILURE",
  PROJECT_LIST_START: "PROJECT_LIST_START",
  PROJECT_LIST_SUCCESS: "PROJECT_LIST_SUCCESS",
  PROJECT_LIST_FAILURE: "PROECT_LIST_FAILURE",
  SEARCH_INPUT_DATA: "SEARCH_INPUT_DATA",
  RESET_SEARCH_INPUT_DATA: "RESET_SEARCH_INPUT_DATA",
  GET_PERMISSIONS_LIST_START: "GET_PERMISSIONS_LIST_START",
  GET_PERMISSIONS_LIST_SUCCESS: "GET_PERMISSIONS_LIST_SUCCESS",
  GET_PERMISSIONS_LIST_FAILURE: "GET_PERMISSIONS_LIST_FAILURE",
  CLEAR_PERMISSION: "CLEAR_PERMISSION",
  CLEAR_ISSUE_DETAILS: "CLEAR_ISSUE_DETAILS",
  PROJECT_LIST_REPORT_DOWNLOAD_START: "PROJECT_LIST_REPORT_DOWNLOAD_START",
  PROJECT_LIST_REPORT_DOWNLOAD_SUCCESS: "PROJECT_LIST_REPORT_DOWNLOAD_SUCCESS",
  PROJECT_LIST_REPORT_DOWNLOAD_FAILURE: "PROJECT_LIST_REPORT_DOWNLOAD_FAILURE",
  CLEAR_PROJECT_LIST_REPORT_DOWNLOAD: "CLEAR_PROJECT_LIST_REPORT_DOWNLOAD",
  WINDOW_RESIZE: "WINDOW_RESIZE",
  GET_FORUM_LIST_START: "GET_FORUM_LIST_START",
  GET_FORUM_LIST_SUCCESS: "GET_FORUM_LIST_SUCCESS",
  GET_FORUM_LIST_FAILURE: "GET_FORUM_LIST_FAILURE",
  GET_BUCKET_LIST_START: "GET_BUCKET_LIST_START",
  GET_BUCKET_LIST_SUCCESS: "GET_BUCKET_LIST_SUCCESS",
  GET_BUCKET_LIST_FAILURE: "GET_BUCKET_LIST_FAILURE",
  GET_MILESTONE_TABLE_START: "GET_MILESTONE_TABLE_START",
  GET_MILESTONE_TABLE_SUCCESS: "GET_MILESTONE_TABLE_SUCCESS",
  GET_MILESTONE_TABLE_FAILURE: "GET_MILESTONE_TABLE_FAILURE",
  GET_MILESTONE_LIST_START: "GET_MILESTONE_LIST_START",
  GET_MILESTONE_LIST_SUCCESS: "GET_MILESTONE_LIST_SUCCESS",
  GET_MILESTONE_LIST_FAILURE: "GET_MILESTONE_LIST_FAILURE",
  UPLOADING_START: "UPLOADING_START",
  UPLOADING_SUCCESS: "UPLOADING_SUCCESS",
  UPLOADING_FAILURE: "UPLOADING_FAILURE"
};

export const PROJECT_DETAILS_ACTION = {
  PROJECT_DETAILS_START: "PROJECT_DETAILS_START",
  PROJECT_DETAILS_SUCCESS: "PROJECT_DETAILS_SUCCESS",
  PROJECT_DETAILS_FAILURE: "PROJECT_DETAILS_FAILURE",
  DRAFTED_PROJECT_DETAILS_START: "DRAFTED_PROJECT_DETAILS_START",
  DRAFTED_PROJECT_DETAILS_SUCCESS: "DRAFTED_PROJECT_DETAILS_SUCCESS",
  DRAFTED_PROJECT_DETAILS_FAILURE: "DRAFTED_PROJECT_DETAILS_FAILURE",
  PROJECT_TIMELINE_START: "PROJECT_TIMELINE_START",
  PROJECT_TIMELINE_SUCCESS: "PROJECT_TIMELINE_SUCCESS",
  PROJECT_TIMELINE_FAILURE: "PROJECT_TIMELINE_FAILURE",
  PROJECT_MILESTONE_START: "PROJECT_MILESTONE_START",
  PROJECT_MILESTONE_SUCCESS: "PROJECT_MILESTONE_SUCCESS",
  PROJECT_MILESTONE_FAILURE: "PROJECT_MILESTONE_FAILURE",
  PROJECT_MEETING_TYPES_START: "PROJECT_MEETING_TYPES_START",
  PROJECT_MEETING_TYPES_SUCCESS: "PROJECT_MEETING_TYPES_SUCCESS",
  PROJECT_MEETING_TYPES_FAILURE: "PROJECT_MEETING_TYPES_FAILURE",
  PROJECT_DECISION_DETAILS_START: "PROJECT_DECISION_DETAILS_START",
  PROJECT_DECISION_DETAILS_SUCCESS: "PROJECT_DECISION_DETAILS_SUCCESS",
  PROJECT_DECISION_DETAILS_FAILURE: "PROJECT_DECISION_DETAILS_FAILURE"
};

export const ISSUE_DETAILS_ACTION = {
  ISSUE_DETAILS_START: "ISSUE_DETAILS_START",
  ISSUE_DETAILS_SUCCESS: "ISSUE_DETAILS_SUCCESS",
  ISSUE_DETAILS_FAILURE: "ISSUE_DETAILS_FAILURE",
  SUBMIT_COMMENT_START: "SUBMIT_COMMENT_START",
  SUBMIT_COMMENT_SUCCESS: "SUBMIT_COMMENT_SUCCESS",
  SUBMIT_COMMENT_FAILURE: "SUBMIT_COMMENT_FAILURE",
  ISSUE_AGEING_REPORT_START: "ISSUE_AGEING_REPORT_START",
  ISSUE_AGEING_REPORT_SUCCESS: "ISSUE_AGEING_REPORT_SUCCESS",
  ISSUE_AGEING_REPORT_FAILURE: "ISSUE_AGEING_REPORT_FAILURE",
  UPCOMING_MEETINGS_START: "UPCOMING_MEETINGS_START",
  UPCOMING_MEETINGS_SUCCESS: "UPCOMING_MEETINGS_SUCCESS",
  UPCOMING_MEETINGS_FAILURE: "UPCOMING_MEETINGS_FAILURE",
  ISSUE_ACTIVITY_HISTORY_START: "ISSUE_ACTIVITY_HISTORY_START",
  ISSUE_ACTIVITY_HISTORY_SUCCESS: "ISSUE_ACTIVITY_HISTORY_SUCCESS",
  ISSUE_ACTIVITY_HISTORY_FAILURE: "ISSUE_ACTIVITY_HISTORY_FAILURE",
  ISSUE_MEETING_START: "ISSUE_MEETING_START",
  ISSUE_MEETING_SUCCESS: "ISSUE_MEETING_SUCCESS",
  ISSUE_MEETING_FAILURE: "ISSUE_MEETING_FAILURE",
  ISSUE_COMMENT_START: "ISSUE_COMMENT_START",
  ISSUE_COMMENT_SUCCESS: "ISSUE_COMMENT_SUCCESS",
  ISSUE_COMMENT_FAILURE: "ISSUE_COMMENT_FAILURE"
};

export const MIS_ACTION = {
  MIS_FILTER_START: "MIS_FILTER_START",
  STATES_MIS_LIST_DATA_START: "STATES_MIS_LIST_DATA_START",
  STATES_MIS_LIST_DATA_SUCCESS: "STATES_MIS_LIST_DATA_SUCCESS",
  STATES_MIS_LIST_DATA_FAILURE: "STATES_MIS_LIST_DATA_FAILURE",
  STATES_MIS_REPORT_LIST_DATA_SUCCESS: "STATES_MIS_REPORT_LIST_DATA_SUCCESS",
  STATES_MIS_REPORT_LIST_DATA_START: "STATES_MIS_REPORT_LIST_DATA_START",
  STATES_MIS_REPORT_LIST_DATA_FAILURE: "STATES_MIS_REPORT_LIST_DATA_FAILURE",
  STATES_MIS_MOM_REPORT_LIST_DATA_SUCCESS:
    "STATES_MIS_MOM_REPORT_LIST_DATA_SUCCESS",
  STATES_MIS_MOM_REPORT_LIST_DATA_START:
    "STATES_MIS_MOM_REPORT_LIST_DATA_START",
  STATES_MIS_MOM_REPORT_LIST_DATA_FAILURE:
    "STATES_MIS_MOM_REPORT_LIST_DATA_FAILURE",
  SELECTED_STATE_VALUE: "SELECTED_STATE_VALUE",
  SELECTED_MONITORING_VALUE: "SELECTED_MONITORING_VALUE",
  SELECTED_MEETING_VALUE: "SELECTED_MEETING_VALUE",
  CLEAR_STATE_VALUE: "CLEAR_STATE_VALUE",
  CLEAR_MONITORING_VALUE: "CLEAR_MONITORING_VALUE",

  MIS_FILTER_SUCCESS: "MIS_FILTER_SUCCESS",
  MIS_FILTER_FAILURE: "MIS_FILTER_FAILURE",
  PROJECT_MINISTRY_START: "PROJECT_MINISTRY_START",
  PROJECT_MINISTRY_SUCCESS: "PROJECT_MINISTRY_SUCCESS",
  PROJECT_MINISTRY_FAILURE: "PROJECT_MINISTRY_FAILURE",
  PROJECT_SCHEME_START: "PROJECT_SCHEME_START",
  PROJECT_SCHEME_SUCCESS: "PROJECT_SCHEME_SUCCESS",
  PROJECT_SCHEME_FAILURE: "PROJECT_SCHEME_FAILURE",
  PROJECT_MULTI_LOCATION_START: "PROJECT_MULTI_LOCATION_START",
  PROJECT_MULTI_LOCATION_SUCCESS: "PROJECT_MULTI_LOCATION_SUCCESS",
  PROJECT_MULTI_LOCATION_FAILURE: "PROJECT_MULTI_LOCATION_FAILURE",
  PROJECT_SINGLE_LOCATION_START: "PROJECT_SINGLE_LOCATION_START",
  PROJECT_SINGLE_LOCATION_SUCCESS: "PROJECT_SINGLE_LOCATION_SUCCESS",
  PROJECT_SINGLE_LOCATION_FAILURE: "PROJECT_SINGLE_LOCATION_FAILURE",

  ISSUE_STATE_START: "ISSUE_STATE_START",
  ISSUE_STATE_SUCCESS: "ISSUE_STATE_SUCCESS",
  ISSUE_STATE_FAILURE: "ISSUE_STATE_FAILURE",

  STATES_ISSUE_LIST_DATA_START: "STATES_ISSUE_LIST_DATA_START",
  STATES_ISSUE_LIST_DATA_SUCCESS: "STATES_ISSUE_LIST_DATA_SUCCESS",
  STATES_ISSUE_LIST_DATA_FAILURE: "STATES_ISSUE_LIST_DATA_FAILURE",

  STATES_MIS_ISSUES_REVIEWED_START: "STATES_MIS_ISSUES_REVIEWED_START",
  STATES_MIS_ISSUES_REVIEWED_SUCCESS: "STATES_MIS_ISSUES_REVIEWED_SUCCESS",
  STATES_MIS_ISSUES_REVIEWED_FAILURE: "STATES_MIS_ISSUES_REVIEWED_FAILURE",

  STATES_MIS_ISSUES_RESOLVED_START: "STATES_MIS_ISSUES_RESOLVED_START",
  STATES_MIS_ISSUES_RESOLVED_SUCCESS: "STATES_MIS_ISSUES_RESOLVED_SUCCESS",
  STATES_MIS_ISSUES_RESOLVED_FAILURE: "STATES_MIS_ISSUES_RESOLVED_FAILURE",

  STATES_MIS_ISSUES_PENDING_START: "STATES_MIS_ISSUES_PENDING_START",
  STATES_MIS_ISSUES_PENDING_SUCCESS: "STATES_MIS_ISSUES_PENDING_SUCCESS",
  STATES_MIS_ISSUES_PENDING_FAILURE: "STATES_MIS_ISSUES_PENDING_FAILURE",

  ISSUE_SUMMARY_CREATE_FILE_START: "ISSUE_SUMMARY_CREATE_FILE_START",
  ISSUE_SUMMARY_CREATE_FILE_SUCCESS: "ISSUE_SUMMARY_CREATE_FILE_SUCCESS",
  ISSUE_SUMMARY_CREATE_FILE_FAILURE: "ISSUE_SUMMARY_CREATE_FILE_FAILURE",

  STATES_MIS_TIMELINE_LASPSED_START: "STATES_MIS_TIMELINE_LASPSED_START",
  STATES_MIS_TIMELINE_LASPSED_SUCCESS: "STATES_MIS_TIMELINE_LASPSED_SUCCESS",
  STATES_MIS_TIMELINE_LASPSED_FAILURE: "STATES_MIS_TIMELINE_LASPSED_FAILURE",

  STATES_MIS_MEETING_COUNT_START: "STATES_MIS_MEETING_COUNT_START",
  STATES__MIS_MEETING_COUNT_SUCCESS: "STATES__MIS_MEETING_COUNT_SUCCESS",
  STATES__MIS_MEETING_COUNT_FAILURE: "STATES__MIS_MEETING_COUNT_FAILURE",

  STATES_MIS_MEETING_DATE_START: "STATES_MIS_MEETING_DATE_START",
  STATES__MIS_MEETING_DATE_SUCCESS: "STATES__MIS_MEETING_DATE_SUCCESS",
  STATES__MIS_MEETING_DATE_FAILURE: "STATES__MIS_MEETING_DATE_FAILURE",

  ISSUE_STATUS_START: "ISSUE_STATUS_START",
  ISSUE_STATUS_SUCCESS: "ISSUE_STATUS_SUCCESS",
  ISSUE_STATUS_FAILURE: "ISSUE_STATUS_FAILURE",

  ISSUE_SUMMARY_URL_START: "ISSUE_SUMMARY_URL_START",
  ISSUE_SUMMARY_URL_SUCCESS: "ISSUE_SUMMARY_URL_SUCCESS",
  ISSUE_SUMMARY_URL_FAILURE: "ISSUE_SUMMARY_URL_FAILURE",

  PROJECT_STATUS_START: "PROJECT_STATUS_START",
  PROJECT_STATUS_SUCCESS: "PROJECT_STATUS_SUCCESS",
  PROJECT_STATUS_FAILURE: "PROJECT_STATUS_FAILURE",

  SCHEME_PROJECT_START: "SCHEME_PROJECT_START",
  SCHEME_PROJECT_SUCCESS: "SCHEME_PROJECT_SUCCESS",
  SCHEME_PROJECT_FAILURE: "SCHEME_PROJECT_FAILURE",

  FETCH_PROJECT_REPORT_START: "FETCH_PROJECT_REPORT_START",
  FETCH_PROJECT_REPORT_SUCCESS: "FETCH_PROJECT_REPORT_SUCCESS",
  FETCH_PROJECT_REPORT_FAILURE: "FETCH_PROJECT_REPORT_FAILURE",

  GET_MOMS_START: "GET_MOMS_START",
  GET_MOMS_SUCCESS: "GET_MOMS_SUCCESS",
  GET_MOMS_FAILURE: "GET_MOMS_FAILURE",

  FETCH_STATE_PROJECT_REPORT_START: "FETCH_STATE_PROJECT_REPORT_START",
  FETCH_STATE_PROJECT_REPORT_SUCCESS: "FETCH_STATE_PROJECT_REPORT_SUCCESS",
  FETCH_STATE_PROJECT_REPORT_FAILURE: "FETCH_STATE_PROJECT_REPORT_FAILURE",

  FETCH_PROJECT_DETAIL_START: "FETCH_PROJECT_DETAIL_START",
  FETCH_PROJECT_DETAIL_SUCCESS: "FETCH_PROJECT_DETAIL_SUCCESS",
  FETCH_PROJECT_DETAIL_FAILURE: "FETCH_PROJECT_DETAIL_FAILURE",

  ACTIVE_REPORT: "ACTIVE_REPORT",

  FETCH_ALL_SCHEMES_START: "FETCH_ALL_SCHEMES_START",
  FETCH_ALL_SCHEMES_SUCCESS: "FETCH_ALL_SCHEMES_SUCCESS",
  FETCH_ALL_SCHEMES_FAILURE: "FETCH_ALL_SCHEMES_FAILURE",

  FETCH_ALL_PROJECT_STATUS_START: "FETCH_ALL_PROJECT_STATUS_START",
  FETCH_ALL_PROJECT_STATUS_SUCCESS: "FETCH_ALL_PROJECT_STATUS_SUCCESS",
  FETCH_ALL_PROJECT_STATUS_FAILURE: "FETCH_ALL_PROJECT_STATUS_FAILURE",

  FETCH_IMPLEMENTATION_MODES_START: "FETCH_IMPLEMENTATION_MODES_START",
  FETCH_IMPLEMENTATION_MODES_SUCCESS: "FETCH_IMPLEMENTATION_MODES_SUCCESS",
  FETCH_IMPLEMENTATION_MODES_FAILURE: "FETCH_IMPLEMENTATION_MODES_FAILURE",

  FETCH_ALL_SECTORS_START: "FETCH_ALL_SECTORS_START",
  FETCH_ALL_SECTORS_SUCCESS: "FETCH_ALL_SECTORS_SUCCESS",
  FETCH_ALL_SECTORS_FAILURE: "FETCH_ALL_SECTORS_FAILURE",

  // Download Reports
  DOWNLOAD_PROJECT_SUMMARY_START: "DOWNLOAD_PROJECT_SUMMARY_START",
  DOWNLOAD_PROJECT_SUMMARY_SUCCESS: "DOWNLOAD_PROJECT_SUMMARY_SUCCESS",
  DOWNLOAD_PROJECT_SUMMARY_FAILURE: "DOWNLOAD_PROJECT_SUMMARY_FAILURE",
  DOWNLOAD_MIS_SUMMARY_STATUS: "DOWNLOAD_MIS_SUMMARY_STATUS",

  FETCH_FLAT_FILE_REPORT_START: "FETCH_FLAT_FILE_REPORT_START",
  FETCH_FLAT_FILE_REPORT_SUCCESS: "FETCH_FLAT_FILE_REPORT_SUCCESS",
  FETCH_FLAT_FILE_REPORT_FAILURE: "FETCH_FLAT_FILE_REPORT_FAILURE",

  FETCH_ALL_ISSUE_CATEGORY_START: "FETCH_ALL_ISSUE_CATEGORY_START",
  FETCH_ALL_ISSUE_CATEGORY_SUCCESS: "FETCH_ALL_ISSUE_CATEGORY_SUCCESS",
  FETCH_ALL_ISSUE_CATEGORY_FAILURE: "FETCH_ALL_ISSUE_CATEGORY_FAILURE",

  FETCH_ISSUE_SUB_CATEGORIES_START: "FETCH_ISSUE_SUB_CATEGORIES_START",
  FETCH_ISSUE_SUB_CATEGORIES_SUCCESS: "FETCH_ISSUE_SUB_CATEGORIES_SUCCESS",
  FETCH_ISSUE_SUB_CATEGORIES_FAILURE: "FETCH_ISSUE_SUB_CATEGORIES_FAILURE",

  STATES_DATA_START: "STATES_DATA_START",
  STATES_DATA_SUCCESS: "STATES_DATA_SUCCESS",
  STATES_DATA_FAILURE: "STATES_DATA_FAILURE",

  DOWNLOAD_ISSUE_COMMENT_START: "DOWNLOAD_ISSUE_COMMENT_START",
  DOWNLOAD_ISSUE_COMMENT_SUCCESS: "DOWNLOAD_ISSUE_COMMENT_SUCCESS",
  DOWNLOAD_ISSUE_COMMENT_FAILURE: "DOWNLOAD_ISSUE_COMMENT_FAILURE",
  DOWNLOAD_ISSUE_COMMENT_URL_SUCCESS: "DOWNLOAD_ISSUE_COMMENT_URL_SUCCESS",

  DOWNLOAD_USER_DETAILS_START: "DOWNLOAD_USER_DETAILS_START",
  DOWNLOAD_USER_DETAILS_SUCCESS: "DOWNLOAD_USER_DETAILS_SUCCESS",
  DOWNLOAD_USER_DETAILS_FAILURE: "DOWNLOAD_USER_DETAILS_FAILURE",

  DOWNLOAD_SPONORING_MINISTRY_START: "DOWNLOAD_USER_DETAILS_START",
  DOWNLOAD_SPONORING_MINISTRY_SUCCESS: "DOWNLOAD_SPONORING_MINISTRY_SUCCESS",
  DOWNLOAD_SPONORING_MINISTRY_FAILURE: "DOWNLOAD_SPONORING_MINISTRY_FAILURE",

  DOCUMENTS_DATA_START: "DOCUMENTS_DATA_START",
  DOCUMENTS_DATA_SUCCESS: "DOCUMENTS_DATA_SUCCESS",
  DOCUMENTS_DATA_FAILURE: "DOCUMENTS_DATA_FAILURE",

  GET_DD_BY_PARENTID_START: "GET_DD_BY_PARENTID_START",
  GET_DD_BY_PARENTID_SUCCESS: "GET_DD_BY_PARENTID_SUCCESS",
  GET_DD_BY_PARENTID_FAILURE: "GET_DD_BY_PARENTID_FAILURE"
};

export const PATHS = {
  LOGIN: "/login",
  ACCESS_DENIED: "/access-denied",
  LOGIN_WITH_PASSWORD: "/login/password",
  LOGIN_WITH_OTP: "/login/otp",
  RESET_PASSWORD: "/reset-password/:token",
  SIGNUP: "/register",
  DASHBOARD: "/dashboard",
  HOME: "/",
  BEST_PRACTICES: "/best-practices",
  CREATE_PROJECT: "/create-project",
  // TERMS_CONDITIONS: "/terms-conditions",
  // PRIVACY_POLICY: "/privacy-policy",
  PREVIEW: "/preview",
  SUCCESS: "/success",
  PROJECT_DETAILS: "/detail-project",
  DETAIL_PROJECT: "/project-detail",
  ISSUE_DETAIL: "/issue-detail",
  ISSUE_LIST: "/issue-list",
  PROJECT_LIST: "/list-project",
  CREATE_AGENDA: "/create-agenda",
  AGENDA_LIST: "/agenda-list",
  AGENDA_DETAILS: "/agenda-details",
  GROUP_MANAGEMENT: "/user-management",
  CMS: "/cms",
  WORKFLOW: "/workflow",
  MIS: "/mis",
  CREATE_GROUP_MANAGEMENT: "/management/create/group",
  CREATE_USER_MANAGEMENT: "/management/create/user",
  CREATE_ROLES_MANAGEMENT: "/management/create/roles",
  PROFILE: "/profile",
  CHANGE_PASSWORD: "/change-password",
  GET_OTP: "/get-otp",
  NO_PAGE_FOUND: "/no-page-found",
  SERVER_ERROR: "/server-error",
  SOMETHING_WENT_WRONG: "/something-went-wrong",
  UNDER_MAINTENANCE: "/under-maintenance",
  IIG_PROJECT_DETAIL: "/iig-project-detail",
  PRAGATI_LISTING_PAGE: "/pragati-list",
  PRAGATI_DETAILS_PAGE: "/pragati-details",
  ARTICLES_DETAILS_PAGE: "/articles-details",
  PMG_PROJECT_DETAIL: "/pmg-project-detail",
  ABOUT_US_PAGE: "/about-us",
  CONTACT_US_PAGE: "/contact-us",
  FEEDBACK_PAGE: "/feedback-and-suggestions",
  SITEMAP: "/sitemap"
};

export const IIG_PATHS = {
  IIG_PROJECT_DETAIL: "/iigProjectDetails",
  // IIG_PROJECT_UPDATE: "/updateIIGProjectDetails"
  IIG_PROJECT_UPDATE: "/iigUpdateProject"
};

export const RESPONSE_CODE = {
  SUCCESS: 200
};

export const CREATE_PROJECT_ACTION = {
  CREATE_PROJECT_START: "CREATE_PROJECT_START",
  CREATE_PROJECT_SUCCESS: "CREATE_PROJECT_SUCCESS",
  CREATE_PROJECT_FAILURE: "CREATE_PROJECT_FAILURE",
  CREATE_PROJECT_PAGE_INFO_START: "CREATE_PROJECT_PAGE_INFO_START",
  CREATE_PROJECT_PAGE_INFO_SUCCESS: "CREATE_PROJECT_PAGE_INFO_SUCCESS",
  CREATE_PROJECT_PAGE_INFO_FAILURE: "CREATE_PROJECT_PAGE_INFO_FAILURE",
  GET_PROJECT_DETAIL_START: "GET_PROJECT_DETAIL_START",
  GET_PROJECT_DETAIL_SUCCESS: "GET_PROJECT_DETAIL_SUCCESS",
  GET_PROJECT_DETAIL_FAILURE: "GET_PROJECT_DETAIL_FAILURE",
  GET_VALIDATE_CIN_START: "GET_VALIDATE_CIN_START",
  GET_VALIDATE_CIN_SUCCESS: "GET_VALIDATE_CIN_SUCCESS",
  GET_VALIDATE_CIN_FAILURE: "GET_VALIDATE_CIN_FAILURE",
  GET_SECTOR_LIST_SUCCESS: "GET_SECTOR_LIST_SUCCESS",
  GET_SUB_SECTOR_LIST_SUCCESS: "GET_SUB_SECTOR_LIST_SUCCESS",
  GET_BANK_LIST_SUCCESS: "GET_BANK_LIST_SUCCESS",
  GET_SCHEMES_LIST_SUCCESS: "GET_SCHEMES_LIST_SUCCESS",
  GET_LOCATION_LIST_SUCCESS: "GET_LOCATION_LIST_SUCCESS",
  GET_IMPLEMENTATION_LIST_SUCCESS: "GET_IMPLEMENTATION_LIST_SUCCESS",
  GET_COST_DISTANCE_SUCCESS: "GET_COST_DISTANCE_SUCCESS",
  GET_GROUP_BY_ID_START: "GET_GROUP_BY_ID_START",
  GET_GROUP_BY_ID_SUCCESS: "GET_GROUP_BY_ID_SUCCESS",
  GET_GROUP_BY_ID_FAILURE: "GET_GROUP_BY_ID_FAILURE",
  GET_ISSUES_STATES_START: "GET_ISSUES_STATES_START",
  GET_ISSUES_STATES_SUCCESS: "GET_ISSUES_STATES_SUCCESS",
  GET_ISSUES_STATES_FAILURE: "GET_ISSUES_STATES_FAILURE",
  GET_DISTRICT_LIST_FOR_LOCATION_START: "GET_DISTRICT_LIST_FOR_LOCATION_START",
  GET_DISTRICT_LIST_FOR_LOCATION_SUCCESS:
    "GET_DISTRICT_LIST_FOR_LOCATION_SUCCESS",
  GET_DISTRICT_LIST_FOR_LOCATION_FAILURE:
    "GET_DISTRICT_LIST_FOR_LOCATION_FAILURE",
  GET_CIRCLE_LIST_FOR_LOCATION_START: "GET_CIRCLE_LIST_FOR_LOCATION_START",
  GET_CIRCLE_LIST_FOR_LOCATION_SUCCESS: "GET_CIRCLE_LIST_FOR_LOCATION_SUCCESS",
  GET_CIRCLE_LIST_FOR_LOCATION_FAILURE: "GET_CIRCLE_LIST_FOR_LOCATION_FAILURE",
  GET_GROUP_BY_CATEGORY_AND_PARENT_ID_START:
    "GET_GROUP_BY_CATEGORY_AND_PARENT_ID_START",
  GET_GROUP_BY_CATEGORY_AND_PARENT_ID_SUCCESS:
    "GET_GROUP_BY_CATEGORY_AND_PARENT_ID_SUCCESS",
  GET_GROUP_BY_CATEGORY_AND_PARENT_ID_FAILURE:
    "GET_GROUP_BY_CATEGORY_AND_PARENT_ID_FAILURE",
  GET_BUCKETS_WITH_MILESTONE_BY_SECTOR_START:
    "GET_BUCKETS_WITH_MILESTONE_BY_SECTOR_START",
  GET_BUCKETS_WITH_MILESTONE_BY_SECTOR_SUCCESS:
    "GET_BUCKETS_WITH_MILESTONE_BY_SECTOR_SUCCESS",
  GET_BUCKETS_WITH_MILESTONE_BY_SECTOR_FAILURE:
    "GET_BUCKETS_WITH_MILESTONE_BSY_SECTOR_FAILURE",
  GET_RESPONSIBLE_AUTHORITY_START: "GET_RESPONSIBLE_AUTHORITY_START",
  GET_RESPONSIBLE_AUTHORITY_SUCCESS: "GET_RESPONSIBLE_AUTHORITY_SUCCESS",
  GET_RESPONSIBLE_AUTHORITY_FAILURE: "GET_RESPONSIBLE_AUTHORITY_FAILURE",
  CREATE_NEW_MILESTONE_START: "CREATE_NEW_MILESTONE_START",
  CREATE_NEW_MILESTONE_SUCCESS: "CREATE_NEW_MILESTONE_SUCCESS",
  CREATE_NEW_MILESTONE_FAILURE: "CREATE_NEW_MILESTONE_FAILURE",
  SAVE_NEW_MILESTONE: "SAVE_NEW_MILESTONE",
  DELETE_NEW_MILESTONE: "DELETE_NEW_MILESTONE",
  DRAFT_NEW_MILESTONE: "DRAFT_NEW_MILESTONE",
  EDIT_MILESTONE_START: "EDIT_MILESTONE_START",
  EDIT_MILESTONE_SUCCESS: "EDIT_MILESTONE_SUCCESS",
  EDIT_MILESTONE_FAILURE: "EDIT_MILESTONE_FAILURE",
  CHECK_ISSUE_DELETION_START: "CHECK_ISSUE_DELETION_START",
  CHECK_ISSUE_DELETION_SUCCESS: "CHECK_ISSUE_DELETION_SUCCESS",
  CHECK_ISSUE_DELETION_FAILURE: "CHECK_ISSUE_DELETION_FAILURE",
  CHECK_ISSUE_DISABLE_START: "CHECK_ISSUE_DISABLE_START",
  CHECK_ISSUE_DISABLE_SUCCESS: "CHECK_ISSUE_DISABLE_SUCCESS",
  CHECK_ISSUE_DISABLE_FAILURE: "CHECK_ISSUE_DISABLE_FAILURE",
  CHECK_ISSUE_BUCKET_DISABLE_START: "CHECK_ISSUE_BUCKET_DISABLE_START",
  CHECK_ISSUE_BUCKET_DISABLE_SUCCESS: "CHECK_ISSUE_BUCKET_DISABLE_SUCCESS",
  CHECK_ISSUE_BUCKET_DISABLE_FAILURE: "CHECK_ISSUE_BUCKET_DISABLE_FAILURE",
  CREATE_PROJECT_DECISION_START: "CREATE_PROJECT_DECISION_START",
  CREATE_PROJECT_DECISION_SUCCESS: "CREATE_PROJECT_DECISION_SUCCESS",
  CREATE_PROJECT_DECISION_FAILURE: "CREATE_PROJECT_DECISION_FAILURE"
};

export const ISSUES_ACTION = {
  CREATE_ISSUE_START: "CREATE_ISSUE_START",
  CREATE_ISSUE_SUCCESS: "CREATE_ISSUE_SUCCESS",
  CREATE_ISSUE_FAILURE: "CREATE_ISSUE_FAILURE"
};

export const DECLARE_MONTHLY_ISSUE_ACTION = {
  DECLARE_ISSUE_START: "DECLARE_ISSUE_START",
  DECLARE_ISSUE_SUCCESS: "DECLARE_ISSUE_SUCCESS",
  DECLARE_ISSUE_FAILURE: "DECLARE_ISSUE_FAILURE"
};

export const WORKFLOW_ACTIONS_ACTION = {
  FETCH_WORKFLOW_ACTIONS_START: "FETCH_WORKFLOW_ACTIONS_START",
  FETCH_WORKFLOW_ACTIONS_SUCCESS: "FETCH_WORKFLOW_ACTIONS_SUCCESS",
  FETCH_WORKFLOW_ACTIONS_FAILURE: "FETCH_WORKFLOW_ACTIONS_FAILURE",

  CREATE_WORKFLOW_ACTION_START: "CREATE_WORKFLOW_ACTION_START",
  CREATE_WORKFLOW_ACTION_SUCCESS: "CREATE_WORKFLOW_ACTION_SUCCESS",
  CREATE_WORKFLOW_ACTION_FAILURE: "CREATE_WORKFLOW_ACTION_FAILURE",

  DELETE_WORKFLOW_ACTION_START: "DELETE_WORKFLOW_ACTION_START",
  DELETE_WORKFLOW_ACTION_SUCCESS: "DELETE_WORKFLOW_ACTION_SUCCESS",
  DELETE_WORKFLOW_ACTION_FAILURE: "DELETE_WORKFLOW_ACTION_FAILURE",

  FETCH_WORKFLOW_STATE_CATEGORY_START: "FETCH_WORKFLOW_STATE_CATEGORY_START",
  FETCH_WORKFLOW_STATE_CATEGORY_SUCCESS:
    "FETCH_WORKFLOW_STATE_CATEGORY_SUCCESS",
  FETCH_WORKFLOW_STATE_CATEGORY_FAILURE:
    "FETCH_WORKFLOW_STATE_CATEGORY_FAILURE",

  CREATE_WORKFLOW_STATE_CATEGORY_START: "CREATE_WORKFLOW_STATE_CATEGORY_START",
  CREATE_WORKFLOW_STATE_CATEGORY_SUCCESS:
    "CREATE_WORKFLOW_STATE_CATEGORY_SUCCESS",
  CREATE_WORKFLOW_STATE_CATEGORY_FAILURE:
    "CREATE_WORKFLOW_STATE_CATEGORY_FAILURE",

  DELETE_WORKFLOW_STATE_CATEGORY_START: "DELETE_WORKFLOW_STATE_CATEGORY_START",
  DELETE_WORKFLOW_STATE_CATEGORY_SUCCESS:
    "DELETE_WORKFLOW_STATE_CATEGORY_SUCCESS",
  DELETE_WORKFLOW_STATE_CATEGORY_FAILURE:
    "DELETE_WORKFLOW_STATE_CATEGORY_FAILURE",

  FETCH_WORKFLOW_STATE_START: "FETCH_WORKFLOW_STATE_START",
  FETCH_WORKFLOW_STATE_SUCCESS: "FETCH_WORKFLOW_STATE_SUCCESS",
  FETCH_WORKFLOW_STATE_FAILURE: "FETCH_WORKFLOW_STATE_FAILURE",

  CREATE_WORKFLOW_STATE_START: "CREATE_WORKFLOW_STATE_START",
  CREATE_WORKFLOW_STATE_SUCCESS: "CREATE_WORKFLOW_STATE_SUCCESS",
  CREATE_WORKFLOW_STATE_FAILURE: "CREATE_WORKFLOW_STATE_FAILURE",

  DELETE_WORKFLOW_STATE_START: "DELETE_WORKFLOW_STATE_START",
  DELETE_WORKFLOW_STATE_SUCCESS: "DELETE_WORKFLOW_STATE_SUCCESS",
  DELETE_WORKFLOW_STATE_FAILURE: "DELETE_WORKFLOW_STATE_FAILURE",

  CREATE_WORKFLOW_START: "CREATE_WORKFLOW_START",
  CREATE_WORKFLOW_SUCCESS: "CREATE_WORKFLOW_SUCCESS",
  CREATE_WORKFLOW_FAILURE: "CREATE_WORKFLOW_FAILURE",

  WORKFLOW_TYPE_START: "CREATE_WORKFLOW_START",
  WORKFLOW_TYPE_SUCCESS: "CREATE_WORKFLOW_SUCCESS",
  WORKFLOW_TYPE_FAILURE: "CREATE_WORKFLOW_FAILURE",

  FETCH_WORKFLOW_START: "FETCH_WORKFLOW_START",
  FETCH_WORKFLOW_SUCCESS: "FETCH_WORKFLOW_SUCCESS",
  FETCH_WORKFLOW_FAILURE: "FETCH_WORKFLOW_FAILURE",

  FETCH_WORKFLOW_STATE_FOR_CENTRAL_START:
    "FETCH_WORKFLOW_STATE_FOR_CENTRAL_START",
  FETCH_WORKFLOW_STATE_FOR_CENTRAL_SUCCESS:
    "FETCH_WORKFLOW_STATE_FOR_CENTRAL_SUCCESS",
  FETCH_WORKFLOW_STATE_FOR_CENTRAL_FAILURE:
    "FETCH_WORKFLOW_STATE_FOR_CENTRAL_FAILURE"
};

export const IMAGE_FORMATS = [".png", ".jpeg", ".jpg"];

export const MAX_CHARACTER_LIMIT = 500;

export const FILE_FORMATS = [
  ".doc",
  ".pdf",
  ".png",
  ".jpeg",
  ".jpg",
  ".msg",
  ".docx",
  ".ppt",
  ".pptx",
  ".kml",
  ".kmz",
  ".mp4",
  ".mov",
  ".wmv",
  ".avi",
  ".mkv"
];
export const FORMAT_DOC_PDF = [".doc", ".pdf"];

export const IMAGE_FORMAT = [".png", ".jpeg", ".jpg"];

export const FILE_FORMAT = [".pdf"];

export const KML_FORMATS = [".kml", ".kmz"];

export const DOCUMENT_FORMATS = [
  ".doc",
  ".pdf",
  ".png",
  ".jpeg",
  ".jpg",
  ".msg",
  ".docx",
  ".ppt",
  ".pptx",
  ".kml",
  ".kmz"
];

export const DOCUMENT_FORMATS_FOR_CONCLUDED_AGENDA = [
  ".doc",
  ".pdf",
  ".png",
  ".jpeg",
  ".jpg",
  ".msg",
  ".docx",
  ".ppt",
  ".pptx",
  ".kml",
  ".kmz",
  ".xls",
  ".xlsx"
];

// export const DOCUMENT_FORMATS_AGENDA = [
//   ".doc",
//   ".pdf",
//   ".png",
//   ".jpeg",
//   ".jpg",
//   ".msg",
//   ".docx",
//   ".ppt",
//   ".pptx",
//   ".kml",
//   ".kmz",
//   ".zip"
// ];

export const OTHER_FORMATS = [
  "doc",
  "pdf",
  "png",
  "jpeg",
  "jpg",
  "msg",
  "docx",
  "ppt",
  "pptx",
  "kml",
  "kmz",
  "xls",
  "xlsx"
];

export const OTHER_FORMATS_AGENDA = [
  "doc",
  "pdf",
  "png",
  "jpeg",
  "jpg",
  "msg",
  "docx",
  "ppt",
  "pptx",
  "kml",
  "kmz",
  "zip"
];

export const VIDEO_FORMATS = [
  "mp4",
  "mov",
  "wmv",
  "avi",
  "mkv",
  "MP4",
  "MOV",
  "WMV",
  "AVI",
  "MKV"
];

export const FILE_SIZE_LIMIT = {
  OTHER_FORMATS: 10000000, //10 MB
  VIDEO_FORMAT: 262144000, //250 MB
  EMAIL_ATTACHMENT: 10485760, // 10MB,
  MIS_USER_MANUAL: 25000000, // 25MB,
  NEWSLETTER: 31457280 //30MB
};

// For Agenda Only
export const FILE_SIZE_LIMIT_AGENDA = {
  OTHER_FORMATS: 30000000, //30 MB
  VIDEO_FORMAT: 262144000, //250 MB
  EMAIL_ATTACHMENT: 10485760, // 10MB,
  MIS_USER_MANUAL: 25000000 // 25MB,
};

export const ERROR_MSG = {
  FILE_FORMAT_MSG: "Only doc, pdf, png, jpeg, jpg, msg.",
  DEFAULT_MSG: "This field is required",
  DEFAULT_MSG_FOR_REPONSE_ERROR: "Something went wrong",
  INVALID_FORM: "Mandatory fields are missing",
  OTHER_PP_INVALID: "Invalid User",
  INVALID_LINK: "Not able to download link",
  DUPLICATED_ISSUES: "Please remove duplicated issues",
  DUPLICATED_ISSUES_IN_PROJECT: "Same issue already exist",
  SELECT_GUEST: "Please select guest",
  DOWNLOAD_SUCCESS: "Download success",
  DOWNLOAD_FAILED: "Download failed",
  DOWNLOADING: "Downloading from server...",
  TIME_CHECK: "From time should be less than to time",
  NO_DATA_FOR_DOWNLOAD: "There is no data",
  ERROR_MESSAGE_403: "You are not authorised to perform this task",
  INVALID_CAPTCHA: "Invalid Captcha",
  NO_DATA_FOUND: "No Data Found",
  CC_LIMIT_EXCEED: "cc can't be more than 48",
  NAME_REQUIRED: "Please enter Name",
  DESIGNATION_REQUIRED: "Please enter Designation"
};

export const USER_MANAGEMENT_ACTION = {
  GET_GROUP_LIST_START: "GET_GROUP_LIST_START",
  GET_GROUP_LIST_SUCCESS: "GET_GROUP_LIST_SUCCESS",
  GET_GROUP_LIST_FAILURE: "GET_GROUP_LIST_FAILURE",
  GET_ROLES_LIST_START: "GET_ROLES_LIST_START",
  GET_ROLES_LIST_SUCCESS: "GET_ROLES_LIST_SUCCESS",
  GET_ROLES_LIST_FAILURE: "GET_ROLES_LIST_FAILURE",
  GET_CATEGORY_LIST_START: "GET_CATEGORY_LIST_START",
  GET_CATEGORY_LIST_SUCCESS: "GET_CATEGORY_LIST_SUCCESS",
  GET_CATEGORY_LIST_FAILURE: "GET_CATEGORY_LIST_FAILURE",
  CREATE_GROUP_START: "CREATE_GROUP_START",
  CREATE_GROUP_SUCCESS: "CREATE_GROUP_SUCCESS",
  CREATE_GROUP_FAILURE: "CREATE_GROUP_FAILURE",
  GET_ROLES_BY_ID_START: "GET_ROLES_BY_ID_START",
  GET_ROLES_BY_ID_SUCCESS: "GET_ROLES_BY_ID_SUCCESS",
  GET_ROLES_BY_ID_FAILURE: "GET_ROLES_BY_ID_FAILURE",
  GET_GROUPS_START: "GET_GROUPS_START",
  GET_GROUPS_SUCCESS: "GET_GROUPS_SUCCESS",
  GET_GROUPS_FAILURE: "GET_GROUPS_FAILURE",
  DELETE_GROUP_START: "DELETE_GROUP_START",
  DELETE_GROUP_SUCCESS: "DELETE_GROUP_SUCCESS",
  DELETE_GROUP_FAILURE: "DELETE_GROUP_FAILURE",
  CREATE_USER_START: "CREATE_USER_START",
  CREATE_USER_SUCCESS: "CREATE_USER_SUCCESS",
  CREATE_USER_FAILURE: "CREATE_USER_FAILURE",
  CREATE_BEST_PRACTICES_START: "CREATE_BEST_PRACTICES_START",
  CREATE_BEST_PRACTICES_SUCCESS: "CREATE_BEST_PRACTICES_SUCCESS",
  CREATE_BEST_PRACTICES_FAILURE: "CREATE_BEST_PRACTICES_FAILURE",
  UPDATE_BEST_PRACTICES_START: "UPDATE_BEST_PRACTICES_START",
  UPDATE_BEST_PRACTICES_SUCCESS: "UPDATE_BEST_PRACTICES_SUCCESS",
  UPDATE_BEST_PRACTICES_FAILURE: "UPDATE_BEST_PRACTICES_FAILURE",
  DELETE_BEST_PRACTICES_START: "DELETE_BEST_PRACTICES_START",
  DELETE_BEST_PRACTICES_SUCCESS: "DELETE_BEST_PRACTICES_SUCCESS",
  DELETE_BEST_PRACTICES_FAILURE: "DELETE_BEST_PRACTICES_FAILURE",

  GET_USER_OTP_START: "GET_USER_OTP_START",
  GET_USER_OTP_SUCCESS: "GET_USER_OTP_SUCCESS",
  GET_USER_OTP_FAILURE: "GET_USER_OTP_FAILURE",

  CREATE_ROLE_START: "CREATE_ROLE_START",
  CREATE_ROLE_SUCCESS: "CREATE_ROLE_SUCCESS",
  CREATE_ROLE_FAILURE: "CREATE_ROLE_FAILURE",
  GET_USERS_LIST_START: "GET_USERS_LIST_START",
  GET_USERS_LIST_SUCCESS: "GET_USERS_LIST_SUCCESS",
  GET_BEST_PRACTICES_LIST_START: "GET_BEST_PRACTICES_LIST_START",
  GET_BEST_PRACTICES_LIST_SUCCESS: "GET_BEST_PRACTICES_LIST_SUCCESS",
  GET_BEST_PRACTICES_LIST_FAILURE: "GET_BEST_PRACTICES_LIST_FAILURE",
  GET_USERS_LIST_FAILURE: "GET_USERS_LIST_FAILURE",
  GET_CATEGORY_LIST_FOR_ROLE_START: "GET_CATEGORY_LIST_FOR_ROLE_START",
  GET_CATEGORY_LIST_FOR_ROLE_SUCCESS: "GET_CATEGORY_LIST_FOR_ROLE_SUCCESS",
  GET_CATEGORY_LIST_FOR_ROLE_FAILURE: "GET_CATEGORY_LIST_FOR_ROLE_FAILURE",
  GET_GROUPS_FOR_USER_START: "GET_GROUPS_FOR_USER_START",
  GET_GROUPS_FOR_USER_SUCCESS: "GET_GROUPS_FOR_USER_SUCCESS",
  GET_GROUPS_FOR_USER_FAILURE: "GET_GROUPS_FOR_USER_FAILURE",
  GET_GROUP_LIST_FILTER_START: "GET_GROUP_LIST_FILTER_START",
  GET_GROUP_LIST_FILTER_SUCCESS: "GET_GROUP_LIST_FILTER_SUCCESS",
  GET_GROUP_LIST_FILTER_FAILURE: "GET_GROUP_LIST_FILTER_FAILURE",
  GET_GROUP_BY_ID_START: "GET_GROUP_BY_ID_START",
  GET_GROUP_BY_ID_SUCCESS: "GET_GROUP_BY_ID_SUCCESS",
  GET_GROUP_BY_ID_FAILURE: "GET_GROUP_BY_ID_FAILURE",
  USERS_LIST: {
    _START: "USERS_LIST_REPORT_START",
    _SUCCESS: "USERS_LIST_REPORT_SUCCESS",
    _FAILURE: "USERS_LIST_REPORT_FAILURE",
    _CLEAR: "USERS_LIST_REPORT_CLEAR"
  },
  GROUPS_LIST: {
    _START: "GROUPS_LIST_REPORT_START",
    _SUCCESS: "GROUPS_LIST_REPORT_SUCCESS",
    _FAILURE: "GROUPS_LIST_REPORT_FAILURE",
    _CLEAR: "GROUPS_LIST_REPORT_CLEAR"
  }
};

export const ROLES_ACTION = {
  GET_PERMISSIONS_LIST_START: "GET_PERMISSIONS_LIST_START",
  GET_PERMISSIONS_LIST_SUCCESS: "GET_PERMISSIONS_LIST_SUCCESS",
  GET_PERMISSIONS_LIST_FAILURE: "GET_PERMISSIONS_LIST_FAILURE",
  CREATE_ROLES_FAILURE: "CREATE_ROLES_FAILURE",
  CREATE_ROLES_START: "CREATE_ROLES_START",
  CREATE_ROLES_SUCCESS: "CREATE_ROLES_SUCCESS"
};

export const CREATE_AGENDA_ACTION = {
  LOAD_PAGE_INFO_START: "LOAD_PAGE_INFO_START",
  LOAD_PAGE_INFO_SUCCESS: "LOAD_PAGE_INFO_SUCCESS",
  LOAD_PAGE_INFO_FAILURE: "LOAD_PAGE_INFO_FAILURE"
};

export const VISIBLE = {
  COUNT: 3
};

export const DASHBOARD = {
  DASHBOARD_SUMMARY_START: "DASHBOARD_SUMMARY_START",
  DASHBOARD_SUMMARY_SUCCESS: "DASHBOARD_SUMMARY_SUCCESS",
  DASHBOARD_SUMMARY_FAILURE: "DASHBOARD_SUMMARY_FAILURE",

  DASHBOARD_TEAMSECTION_START: "DASHBOARD_TEAMSECTION_START",
  DASHBOARD_TEAMSECTION_SUCCESS: "DASHBOARD_TEAMSECTION_SUCCESS",
  DASHBOARD_TEAMSECTION_FAILURE: "DASHBOARD_TEAMSECTION_FAILURE",

  PROJECTS_BY_PRAGATI_START: "PROJECTS_BY_PRAGATI_START",
  PROJECTS_BY_PRAGATI_SUCCESS: "PROJECTS_BY_PRAGATI_SUCCESS",
  PROJECTS_BY_PRAGATI_FAILURE: "PROJECTS_BY_PRAGATI_FAILURE",

  DELAYED_PROJECTS_START: "DELAYED_PROJECTS_START",
  DELAYED_PROJECTS_SUCCESS: "DELAYED_PROJECTS_SUCCESS",
  DELAYED_PROJECTS_FAILURE: "DELAYED_PROJECTS_FAILURE",

  ISSUES_BY_CATEGORY_START: "ISSUES_BY_CATEGORY_START",
  ISSUES_BY_CATEGORY_SUCCESS: "ISSUES_BY_CATEGORY_SUCCESS",
  ISSUES_BY_CATEGORY_FAILURE: "ISSUES_BY_CATEGORY_FAILURE",

  ISSUES_BY_CATEGORY_GANTT_CHART_START: "ISSUES_BY_CATEGORY_GANTT_CHART_START",
  ISSUES_BY_CATEGORY_GANTT_CHART_SUCCESS:
    "ISSUES_BY_CATEGORY_GANTT_CHART_SUCCESS",
  ISSUES_BY_CATEGORY_GANTT_CHART_FAILURE:
    "ISSUES_BY_CATEGORY_GANTT_CHART_FAILURE",

  ISSUES_BY_START: "ISSUES_BY_START",
  ISSUES_BY_SUCCESS: "ISSUES_BY_SUCCESS",
  ISSUES_BY_FAILURE: "ISSUES_BY_FAILURE",

  PROJECTS_BY_START: "PROJECTS_BY_START",
  PROJECTS_BY_SUCCESS: "PROJECTS_BY_SUCCESS",
  PROJECTS_BY_FAILURE: "PROJECTS_BY_FAILURE",

  PROJECTS_BY_LOCATION_START: "PROJECTS_BY_LOCATION_START",
  PROJECTS_BY_LOCATION_SUCCESS: "PROJECTS_BY_LOCATION_SUCCESS",
  PROJECTS_BY_LOCATION_FAILURE: "PROJECTS_BY_LOCATION_FAILURE",

  GET_KANBAN_START: "GET_KANBAN_START",
  GET_KANBAN_SUCCESS: "GET_KANBAN_SUCCESS",
  GET_KANBAN_FAILURE: "GET_KANBAN_FAILURE",

  FETCH_MEETINGS_START: "FETCH_MEETINGS_START",
  FETCH_MEETINGS_SUCCESS: "FETCH_MEETINGS_SUCCESS",
  FETCH_MEETINGS_FAILURE: "FETCH_MEETINGS_FAILURE",

  DASHBOARD_NOTIFICATION_START: "DASHBOARD_NOTIFICATION_START",
  DASHBOARD_NOTIFICATION_SUCCESS: "DASHBOARD_NOTIFICATION_SUCCESS",
  DASHBOARD_NOTIFICATION_FAILURE: "DASHBOARD_NOTIFICATION_FAILURE",

  DASHBOARD_NOTIFYSTATUS_START: "DASHBOARD_NOTIFYSTATUS_START",
  DASHBOARD_NOTIFYSTATUS_SUCCESS: "DASHBOARD_NOTIFYSTATUS_SUCCESS",
  DASHBOARD_NOTIFYSTATUS_FAILURE: "DASHBOARD_NOTIFYSTATUS_FAILURE",

  DASHBOARD_NOTIFYSTATUS_UPDATES_START: "DASHBOARD_NOTIFYSTATUS_UPDATES_START",
  DASHBOARD_NOTIFYSTATUS_UPDATES_SUCCESS:
    "DASHBOARD_NOTIFYSTATUS_UPDATES_SUCCESS",
  DASHBOARD_NOTIFYSTATUS_UPDATES_FAILURE:
    "DASHBOARD_NOTIFYSTATUS_UPDATES_FAILURE",

  GET_KANBAN_LIST_START: "GET_KANBAN_LIST_START",
  GET_KANBAN_LIST_SUCCESS: "GET_KANBAN_LIST_SUCCESS",
  GET_KANBAN_LIST_FAILURE: "GET_KANBAN_LIST_FAILURE",

  GET_UPCOMING_MEETINGS_START: "GET_UPCOMING_MEETINGS_START",
  GET_UPCOMING_MEETINGS_SUCCESS: "GET_UPCOMING_MEETINGS_SUCCESS",
  GET_UPCOMING_MEETINGS_FAILURE: "GET_UPCOMING_MEETINGS_FAILURE",

  GET_CHILD_ISSUE_START: "GET_CHILD_ISSUE_START",
  GET_CHILD_ISSUE_SUCCESS: "GET_CHILD_ISSUE_SUCCESS",
  GET_CHILD_ISSUE_FAILURE: "GET_CHILD_ISSUE_FAILURE",

  _START: "DASHBOARD_NOTIFICAION_START",
  _SUCCESS: "DASHBOARD_NOTIFICAION_SUCCESS",
  _FAILURE: "DASHBOARD_NOTIFICAION_FAILURE",

  COST_OVERRUN_PROJECTS_START: "COST_OVERRUN_PROJECTS_START",
  COST_OVERRUN_PROJECTS_SUCCESS: "COST_OVERRUN_PROJECTS_SUCCESS",
  COST_OVERRUN_PROJECTS_FAILURE: "COST_OVERRUN_PROJECTS_FAILURE",

  PMG_MEETING_STATUS_START: "PMG_MEETING_STATUS_START",
  PMG_MEETING_STATUS_SUCCESS: "PMG_MEETING_STATUS_SUCCESS",
  PMG_MEETING_STATUS_FAILURE: "PMG_MEETING_STATUS_FAILURE",

  PROJECT_STAGES_GRAPHS_START: "PROJECT_STAGES_GRAPHS_START",
  PROJECT_STAGES_GRAPHS_SUCCESS: "PROJECT_STAGES_GRAPHS_SUCCESS",
  PROJECT_STAGES_GRAPHS_FAILURE: "PROJECT_STAGES_GRAPHS_FAILURE"
};

export const ADD_DECISION_ACTION = {
  ADD_DECISION_START: "ADD_DECISION_START",
  ADD_DECISION_SUCCESS: "ADD_DECISION_SUCCESS",
  ADD_DECISION_FAILURE: "ADD_DECISION_FAILURE",
  ADD_DECISION_MINISTRY_LIST_START: "ADD_DECISION_MINISTRY_LIST_START",
  ADD_DECISION_MINISTRY_LIST_SUCCESS: "ADD_DECISION_MINISTRY_LIST_SUCCESS",
  ADD_DECISION_MINISTRY_LIST_ERROR: "ADD_DECISION_MINISTRY_LIST_ERROR"
};

export const FORM_DATA_ACTION = {
  SET_PREVIEW_DATA: "SET_PREVIEW_DATA",
  CLEAR_PREVIEW_DATA: "CLEAR_PREVIEW_DATA"
};

export const ISSUE_ACTION = {
  ISSUE_ACTION_CHANGE_STATUS_START: "ISSUE_ACTION_CHANGE_STATUS_START",
  ISSUE_ACTION_CHANGE_STATUS_SUCCESS: "ISSUE_ACTION_CHANGE_STATUS_SUCCESS",
  ISSUE_ACTION_CHANGE_STATUS_FAILURE: "ISSUE_ACTION_CHANGE_STATUS_FAILURE",
  POST_COMMENT_START: "POST_COMMENT_START",
  POST_COMMENT_SUCCESS: "POST_COMMENT_SUCCESS",
  POST_COMMENT_FAILURE: "POST_COMMENT_FAILURE",
  ISSUE_CLARIFICATION_START: "ISSUE_CLARIFICATION_START",
  ISSUE_CLARIFICATION_SUCCESS: "ISSUE_CLARIFICATION_SUCCESS",
  ISSUE_CLARIFICATION_FAILURE: "ISSUE_CLARIFICATION_FAILURE",
  ISSUE_GUEST_LIST_START: "ISSUE_GUEST_LIST_START",
  ISSUE_GUEST_LIST_SUCCESS: "ISSUE_GUEST_LIST_SUCCESS",
  ISSUE_GUEST_LIST_FAILURE: "ISSUE_GUEST_LIST_FAILURE",
  CLEAR_ISSUE_DETAILS: "CLEAR_ISSUE_DETAILS",
  ISSUE_LIST_REPORT_DOWNLOAD_START: "ISSUE_LIST_REPORT_DOWNLOAD_START",
  ISSUE_LIST_REPORT_DOWNLOAD_SUCCESS: "ISSUE_LIST_REPORT_DOWNLOAD_SUCCESS",
  ISSUE_LIST_REPORT_DOWNLOAD_FAILURE: "ISSUE_LIST_REPORT_DOWNLOAD_FAILURE",
  CLEAR_ISSUE_LIST_REPORT_DOWNLOAD: "CLEAR_ISSUE_LIST_REPORT_DOWNLOAD",
  MARK_ISSUE_DUPLICATE_START: "MARK_ISSUE_DUPLICATE_START",
  MARK_ISSUE_DUPLICATE_SUCCESS: "MARK_ISSUE_DUPLICATE_SUCCESS",
  MARK_ISSUE_DUPLICATE_FAILURE: "MARK_ISSUE_DUPLICATE_FAILURE"
};

export const KANBAN_ACTION = {
  GET_KANBAN_START: "GET_KANBAN_START",
  GET_KANBAN_SUCCESS: "GET_KANBAN_SUCCESS",
  GET_KANBAN_FAILURE: "GET_KANBAN_FAILURE"
};

export const AGEING_ACTION = {
  GET_AGEING_START: "GET_AGEING_START",
  GET_AGEING_SUCCESS: "GET_AGEING_SUCCESS",
  GET_AGEING_FAILURE: "GET_AGEING_FAILURE",
  GET_UPCOMMING_MEETINGS_START: "GET_UPCOMMING_MEETINGS_START",
  GET_UPCOMMING_MEETINGS_FAILURE: "GET_UPCOMMING_MEETINGS_FAILURE",
  GET_UPCOMMING_MEETINGS_SUCCESS: "GET_UPCOMMING_MEETINGS_SUCCESS"
};

export const NEWS_FEED_URLS = [
  "https://economictimes.indiatimes.com/industry/energy/rssfeeds/13358350.cms",
  "https://economictimes.indiatimes.com/industry/transportation/rssfeeds/13353990.cms"
];

export const SORTING_PARAMS = {};

export const ISSUE_STATUS = {
  HOLD: "Hold",
  RESOLVED: "Resolved",
  REJECT: "Reject",
  REJECTED: "Rejected",
  hold: "hold",
  resolved: "resolved",
  reject: "reject",
  "Pending with RM/RS": "Pending with RM/RS",
  "Pending with PMG": "Pending with PMG",
  "Pending with SM": "Pending with SM",
  "On Hold": "On Hold"
};

export const PMG_TEAM = [
  {
    name: "SD Sharma",
    designation: "Joint Secretary, DPIIT",
    tel: "01123063554",
    email: "som.sharma@nic.in",
    address: "Udyog Bhawan, New Delhi"
  },
  {
    name: "A.M. Balraj",
    designation: "Sr. Development Officer, DPIIT",
    tel: "011 23062635",
    email: "a.mahendru.nic.in",
    address: "Udyog Bhawan, New Delhi"
  },
  {
    name: "Shri Anshu Mauli Kumar",
    designation: "Under-Secretary, DPIIT",
    tel: "01123063164",
    email: "amkumar@nic.in",
    address: "Udyog Bhawan, New Delhi"
  },
  {
    name: "Vishal Kumar",
    designation: "Assistant Vice-President, Invest India",
    //tel: "+919971200821",
    email: "vishal.kumar@investindia.org.in",
    address: "Vigyan Bhawan Annexe, New Delhi"
  },
  {
    name: "Arihant Kumar",
    designation: "Manager, Invest India",
    tel: "+919711277811",
    email: "arihant.kumar@investindia.org.in",
    address: "Vigyan Bhawan Annexe, New Delhi"
  },
  {
    name: "Arushi Gupta",
    designation: "Assistant Manager",
    tel: "+919650901088",
    email: "arushi.gupta@investindia.org.in",
    address: "Vigyan Bhawan Annexe, New Delhi"
  },
  {
    name: "Yashita Jhurani",
    designation: "Assistant Manager",
    tel: "+919205057443",
    email: "yashita.jhurani@investindia.org.in ",
    address: "Vigyan Bhawan Annexe, New Delhi"
  },
  {
    name: "Tushara Ravindranath",
    designation: "Associate",
    tel: "+919650901088",
    email: "tushara.ravindranath@investindia.org.in",
    address: "Vigyan Bhawan Annexe, New Delhi"
  },
  {
    name: "Drushti Joshi",
    designation: "Associate, Invest India",
    tel: "+919205697822",
    email: "drushti.joshi@investindia.org.in",
    address: "Vigyan Bhawan Annexe, New Delhi"
  },
  {
    name: "Akshat Ganeriwala",
    designation: "Consultant, Invest India",
    tel: "+91 9205177993",
    email: "akshat.ganeriwala@investindia.org.in",
    address: "Vigyan Bhawan Annexe, New Delhi"
  }
];

export const FILTERS = {
  ISSUE_LIST_FILTERS_UPDATED: "ISSUE_LIST_FILTERS_UPDATED",
  ISSUE_LIST_OLD_FILTERS_UPDATED: "ISSUE_LIST_OLD_FILTERS_UPDATED",
  CLEAR_ISSUE_LIST_OLD_FILTERS_UPDATED: "CLEAR_ISSUE_LIST_OLD_FILTERS_UPDATED"
};

export const NOTIFICATION_MAPPER = {
  _DISABLE: "DISABLE",
  _ENABLE: "ENABLE"
};

export const NOTIFICATION_TOOGLE = {
  NOTIFICATION_TOOGLE_START: "NOTIFICATION_TOOGLE_START",
  NOTIFICATION_TOOGLE_SUCCESS: "NOTIFICATION_TOOGLE_SUCCESS",
  NOTIFICATION_TOOGLE_FAILURE: "NOTIFICATION_TOOGLE_FAILURE",
  NOTIFICATION_TOOGLE_UPDATE_STATUS: "NONOTIFICATION_TOOGLE_UPDATE_STATUS"
};

export const DOWNLOAD_EXCEL_CONSTANTS = {
  NODAL_OFFICER: {
    _START: "NODAL_OFFICER_START",
    _SUCCESS: "NODAL_OFFICER_SUCCESS",
    _FAILURE: "NODAL_OFFICER_FAILURE"
  },
  AGENDA_LIST: {
    _START: "AGENDA_LIST_START",
    _SUCCESS: "AGENDA_LIST_SUCCESS",
    _FAILURE: "AGENDA_LIST_FAILURE",
    _CLEAR: "AGENDA_CLEAR"
  },
  WEEKLY_REPORT: {
    _START: "WEEKLY_REPORT_START",
    _SUCCESS: "WEEKLY_REPORT_SUCCESS",
    _FAILURE: "WEEKLY_REPORT_FAILURE",
    _CLEAR: "WEEKLY_REPORT_CLEAR"
  },
  USER_DETAIL_REPORT: {
    _START: "USER_DETAIL_START",
    _SUCCESS: "USER_DETAIL_SUCCESS",
    _FAILURE: "USER_DETAIL_FAILURE",
    _CLEAR: "USER_DETAIL_CLEAR"
  },
  ISSUE_COMMENT: {
    _START: "ISSUE_COMMENT_START",
    _SUCCESS: "ISSUE_COMMENT_SUCCESS",
    _FAILURE: "ISSUE_COMMENT_FAILURE",
    _CLEAR: "ISSUE_COMMENT_CLEAR"
  },
  DECISSION: {
    _START: "DECISSION_START",
    _SUCCESS: "DECISSION_SUCCESS",
    _FAILURE: "DECISSION_FAILURE",
    _CLEAR: "DECISSION_CLEAR"
  },
  MINISTRY_STATE_ISSUE_REPORT: {
    _START: "MINISTRY_STATE_ISSUE_REPORT_START",
    _SUCCESS: "MINISTRY_STATE_ISSUE_REPORT_SUCCESS",
    _FAILURE: "MINISTRY_STATE_ISSUE_REPORT_FAILURE",
    _CLEAR: "MINISTRY_STATE_ISSUE_REPORT_CLEAR"
  },
  DASHBOARD_SUMMARY: {
    _START: "DASHBOARD_SUMMARY_REPORT_START",
    _SUCCESS: "DASHBOARD_SUMMARY_REPORT_SUCCESS",
    _FAILURE: "DASHBOARD_SUMMARY_REPORT_FAILURE",
    _CLEAR: "DASHBOARD_SUMMARY_REPORT_CLEAR"
  },
  PROJECT_LIST: {
    _START: "PROJECT_LIST_REPORT_START",
    _SUCCESS: "PROJECT_LIST_REPORT_SUCCESS",
    _FAILURE: "PROJECT_LIST_REPORT_FAILURE",
    _CLEAR: "PROJECT_LIST_REPORT_CLEAR"
  },
  ISSUE_LIST: {
    _START: "ISSUE_LIST_REPORT_START",
    _SUCCESS: "ISSUE_LIST_REPORT_SUCCESS",
    _FAILURE: "ISSUE_LIST_REPORT_FAILURE",
    _CLEAR: "ISSUE_LIST_REPORT_CLEAR"
  },
  MIS_REPORTS: {
    _START: "MIS_REPORTS_START",
    _SUCCESS: "MIS_REPORTS_SUCCESS",
    _FAILURE: "MIS_REPORTS_FAILURE",
    _CLEAR: "MIS_REPORTS_CLEAR"
  },
  AGENDA_REPORTS_DOWNLOAD: {
    _START: "AGENDA_REPORTS_DOWNLOAD_START",
    _SUCCESS: "AGENDA_REPORTS_DOWNLOAD_SUCCESS",
    _FAILURE: "AGENDA_REPORTS_DOWNLOAD_FAILURE",
    _CLEAR: "AGENDA_REPORTS_DOWNLOAD_CLEAR"
  },
  AGENDA_REPORTS_UPLOAD: {
    _START: "AGENDA_REPORTS_UPLOAD_START",
    _SUCCESS: "AGENDA_REPORTS_UPLOAD_SUCCESS",
    _FAILURE: "AGENDA_REPORTS_UPLOAD_FAILURE",
    _CLEAR: "AGENDA_REPORTS_UPLOAD_CLEAR"
  },
  DOWNLOAD_MINSTRY_STATE: {
    _START: "DOWNLOAD_MINSTRY_STATE_START",
    _SUCCESS: "DOWNLOAD_MINSTRY_STATE_SUCCESS",
    _FAILURE: "DOWNLOAD_MINSTRY_STATE_FAILURE",
    _CLEAR: "DOWNLOAD_MINSTRY_STATE_CLEAR"
  },
  DOWNLOAD_PROJECT_DETAIL_STATE: {
    _START: "DOWNLOAD_PROJECT_DETAIL_STATE_START",
    _SUCCESS: "DOWNLOAD_PROJECT_DETAIL_STATE_SUCCESS",
    _FAILURE: "DOWNLOAD_PROJECT_DETAIL_STATE_FAILURE",
    _CLEAR: "DOWNLOAD_PROJECT_DETAIL_STATE_CLEAR"
  },
  DOWNLOAD_USER_MANUAL_LIST: {
    _START: "DOWNLOAD_USER_MANUAL_LIST_START",
    _SUCCESS: "DOWNLOAD_USER_MANUAL_LIST_SUCCESS",
    _FAILURE: "DOWNLOAD_USER_MANUAL_LIST_FAILURE",
    _CLEAR: "DOWNLOAD_USER_MANUAL_LIST_CLEAR"
  },
  DOWNLOAD_USER_MANUAL: {
    _SUCCESS: "DOWNLOAD_USER_MANUAL"
  },
  WEEKLY_REPORT_FOR_STATE_PMG: {
    _START: "WEEKLY_REPORT_FOR_STATE_PMG_START",
    _SUCCESS: "WEEKLY_REPORT_FOR_STATE_PMG_SUCCESS",
    _FAILURE: "WEEKLY_REPORT_FOR_STATE_PMG_FAILURE",
    _CLEAR: "WEEKLY_REPORT_FOR_STATE_PMG_CLEAR"
  },
  AGENDA_MEETING_PPT_V2: {
    _START: "AGENDA_MEETING_PPT_V2_START",
    _SUCCESS: "AGENDA_MEETING_PPT_V2_SUCCESS",
    _FAILURE: "AGENDA_MEETING_PPT_V2_FAILURE",
    _CLEAR: "AGENDA_MEETING_PPT_V2_CLEAR"
  },
  AGENDA_MEETING_PPT_V2_WITHOUT_ISSUE: {
    _START: "AGENDA_MEETING_PPT_V2_WITHOUT_ISSUE_START",
    _SUCCESS: "AGENDA_MEETING_PPT_V2_WITHOUT_ISSUE_SUCCESS",
    _FAILURE: "AGENDA_MEETING_PPT_V2_WITHOUT_ISSUE_FAILURE",
    _CLEAR: "AGENDA_MEETING_PPT_V2_WITHOUT_ISSUE_CLEAR"
  },
  AGENDA_MEETING_PPT_V2_PRAGATI_FORMAT: {
    _START: "AGENDA_MEETING_PPT_V2_PRAGATI_FORMAT_START",
    _SUCCESS: "AGENDA_MEETING_PPT_V2_PRAGATI_FORMAT_SUCCESS",
    _FAILURE: "AGENDA_MEETING_PPT_V2_PRAGATI_FORMAT_FAILURE",
    _CLEAR: "AGENDA_MEETING_PPT_V2_PRAGATI_FORMAT_CLEAR"
  },
  AGENDA_MEETING_PPT: {
    _START: "AGENDA_MEETING_PPT_START",
    _SUCCESS: "AGENDA_MEETING_PPT_SUCCESS",
    _FAILURE: "AGENDA_MEETING_PPT_FAILURE",
    _CLEAR: "AGENDA_MEETING_PPT_CLEAR"
  },
  AGENDA_MEETING_CABSEC_PPT: {
    _START: "AGENDA_MEETING_CABSEC_PPT_START",
    _SUCCESS: "AGENDA_MEETING_CABSEC_PPT_SUCCESS",
    _FAILURE: "AGENDA_MEETING_CABSEC_PPT_FAILURE",
    _CLEAR: "AGENDA_MEETING_CABSEC_PPT_CLEAR"
  },
  AGENDA_MEETING_EXCEL: {
    _START: "AGENDA_MEETING_EXCEL_START",
    _SUCCESS: "AGENDA_MEETING_EXCEL_SUCCESS",
    _FAILURE: "AGENDA_MEETING_EXCEL_FAILURE",
    _CLEAR: "AGENDA_MEETING_EXCEL_CLEAR"
  },
  ISSUE_BRIEF: {
    _START: "ISSUE_BRIEF_REPORT_START",
    _SUCCESS: "ISSUE_BRIEF_REPORT_SUCCESS",
    _FAILURE: "ISSUE_BRIEF_REPORT_FAILURE",
    _CLEAR: "ISSUE_BRIEF_REPORT_CLEAR"
  },
  ISSUE_BRIEF_PDF: {
    _START: "ISSUE_BRIEF_PDF_REPORT_START",
    _SUCCESS: "ISSUE_BRIEF_PDF_REPORT_SUCCESS",
    _FAILURE: "ISSUE_BRIEF_PDF_REPORT_FAILURE",
    _CLEAR: "ISSUE_BRIEF_PDF_REPORT_CLEAR"
  },
  DOWNLOAD_MILESTONE_AUDIT: {
    _START: "DOWNLOAD_MILESTONE_AUDIT_START",
    _SUCCESS: "DOWNLOAD_MILESTONE_AUDIT_SUCCESS",
    _FAILURE: "DOWNLOAD_MILESTONE_AUDIT_FAILURE",
    _CLEAR: "DOWNLOAD_MILESTONE_AUDIT_CLEAR"
  },
  MARCH24_REPORT: {
    _START: "MARCH24_REPORT_START",
    _SUCCESS: "MARCH24_REPORT_SUCCESS",
    _FAILURE: "MARCH24_REPORT_FAILURE",
    _CLEAR: "MARCH24_REPORT_CLEAR"
  },
  UPLOAD_AGENDA_TMP: {
    _START: "UPLOAD_AGENDA_TMP_START",
    _SUCCESS: "UPLOAD_AGENDA_TMP_SUCCESS",
    _FAILURE: "UPLOAD_AGENDA_TMP_FAILURE",
    _CLEAR: "UPLOAD_AGENDA_TMP_CLEAR"
  },
  UPLOAD_PROJECT_ISSUES: {
    _START: "UPLOAD_PROJECT_ISSUES_START",
    _SUCCESS: "UPLOAD_PROJECT_ISSUES_SUCCESS",
    _FAILURE: "UPLOAD_PROJECT_ISSUES_FAILURE",
    _CLEAR: "UPLOAD_PROJECT_ISSUES_CLEAR"
  }
};

export function getDashBoardOpenProjectGroupCategoryPayload(
  groupCategory,
  summaryType,
  stateAndCentralProjectSelectedBy
) {
  if (groupCategory === "DISTRICT" || groupCategory === "STATE_DEPARTMENT") {
    return stateAndCentralProjectSelectedBy === "CENTRAL" ? "CENTRAL" : "STATE";
  } else if (groupCategory === "STATE" || groupCategory === "STATE_PMG") {
    return summaryType === "RECIPIENT" ? "CENTRAL" : "STATE";
  } else if (groupCategory === "PMG" || groupCategory === "CENTRAL") {
    return "CENTRAL";
  }
}

export const REDIRECTION_DASHBOARD_URLS = (
  type,
  checkedValue,
  groupCategory,
  summaryType,
  user,
  stateAndCentralProjectSelectedBy
) => {
  const isStateAndDistrictUser =
    groupCategory === "DISTRICT" || groupCategory === "STATE_DEPARTMENT";
  const sections = {
    summary: {
      open: {
        groupCategory: getDashBoardOpenProjectGroupCategoryPayload(
          groupCategory,
          summaryType,
          stateAndCentralProjectSelectedBy
        ),
        projectFlags: [
          checkedValue ? { displayName: "MARCH 24", key: "MARCH 24" } : null
        ],
        projectTags: [{ key: "OPEN", displayName: "OPEN" }],
        projectStage: [{ key: "VERIFIED", displayName: "VERIFIED" }],
        sponsoringMinistry:
          (groupCategory === "CENTRAL" ||
            groupCategory === "CENTRAL_DEPARTMENT") &&
          summaryType === "SPONSOR"
            ? [
                {
                  key: user.groupId.toString(),
                  displayName: user.groupName
                }
              ]
            : [],
        recipientMinistry:
          (groupCategory === "STATE" ||
            groupCategory === "CENTRAL" ||
            groupCategory === "CENTRAL_DEPARTMENT") &&
          summaryType === "RECIPIENT"
            ? [
                {
                  key: user.groupId.toString(),
                  displayName: user.groupName
                }
              ]
            : summaryType === "RECIPIENT" && groupCategory === "STATE_PMG"
            ? [
                {
                  key: user.childGroupId.toString(),
                  displayName: user.groupName
                }
              ]
            : [],
        sponsoringState:
          summaryType === "SPONSOR" && groupCategory === "STATE"
            ? [
                {
                  key: user.groupId.toString(),
                  displayName: user.groupName
                }
              ]
            : summaryType === "SPONSOR" && groupCategory === "STATE_PMG"
            ? [
                {
                  key: user.childGroupId.toString(),
                  displayName: user.groupName
                }
              ]
            : []
      },
      resolved: {
        groupCategory: getDashBoardOpenProjectGroupCategoryPayload(
          groupCategory,
          summaryType,
          stateAndCentralProjectSelectedBy
        ),
        projectFlags: [
          checkedValue ? { displayName: "MARCH 24", key: "MARCH 24" } : null
        ],
        projectStage: [{ key: "VERIFIED", displayName: "VERIFIED" }],
        projectTags: [{ key: "RESOLVED", displayName: "RESOLVED" }],
        sponsoringMinistry:
          (groupCategory === "CENTRAL" ||
            groupCategory === "CENTRAL_DEPARTMENT") &&
          summaryType === "SPONSOR"
            ? [
                {
                  key: user.groupId.toString(),
                  displayName: user.groupName
                }
              ]
            : [],
        recipientMinistry:
          (groupCategory === "STATE" ||
            groupCategory === "CENTRAL" ||
            groupCategory === "CENTRAL_DEPARTMENT") &&
          summaryType === "RECIPIENT"
            ? [
                {
                  key: user.groupId.toString(),
                  displayName: user.groupName
                }
              ]
            : summaryType === "RECIPIENT" && groupCategory === "STATE_PMG"
            ? [
                {
                  key: user.childGroupId.toString(),
                  displayName: user.groupName
                }
              ]
            : [],
        sponsoringState:
          summaryType === "SPONSOR" && groupCategory === "STATE"
            ? [
                {
                  key: user.groupId.toString(),
                  displayName: user.groupName
                }
              ]
            : summaryType === "SPONSOR" && groupCategory === "STATE_PMG"
            ? [
                {
                  key: user.childGroupId.toString(),
                  displayName: user.groupName
                }
              ]
            : []
      },
      noIssues: {
        groupCategory: getDashBoardOpenProjectGroupCategoryPayload(
          groupCategory,
          summaryType,
          stateAndCentralProjectSelectedBy
        ),
        projectFlags: [
          checkedValue ? { displayName: "MARCH 24", key: "MARCH 24" } : null
        ],
        projectStage: [{ key: "VERIFIED", displayName: "VERIFIED" }],
        projectTags: [
          { key: "NO_ISSUES_OR_ALL_REJECTED", displayName: "NO ISSUES" }
        ],

        sponsoringState:
          summaryType === "SPONSOR" && groupCategory === "STATE"
            ? [
                {
                  key: user.groupId.toString(),
                  displayName: user.groupName
                }
              ]
            : summaryType === "SPONSOR" && groupCategory === "STATE_PMG"
            ? [
                {
                  key: user.childGroupId.toString(),
                  displayName: user.groupName
                }
              ]
            : [],
        sponsoringMinistry:
          (groupCategory === "CENTRAL" ||
            groupCategory === "CENTRAL_DEPARTMENT") &&
          summaryType === "SPONSOR"
            ? [
                {
                  key: user.groupId.toString(),
                  displayName: user.groupName
                }
              ]
            : [],
        recipientMinistry:
          (groupCategory === "STATE" ||
            groupCategory === "CENTRAL" ||
            groupCategory === "CENTRAL_DEPARTMENT") &&
          summaryType === "RECIPIENT"
            ? [
                {
                  key: user.groupId.toString(),
                  displayName: user.groupName
                }
              ]
            : summaryType === "RECIPIENT" && groupCategory === "STATE_PMG"
            ? [
                {
                  key: user.childGroupId.toString(),
                  displayName: user.groupName
                }
              ]
            : []
      }
    },
    summary_pragati: {
      open: {
        groupCategory: getDashBoardOpenProjectGroupCategoryPayload(
          groupCategory,
          summaryType,
          stateAndCentralProjectSelectedBy
        ),
        projectStage: [{ key: "VERIFIED", displayName: "VERIFIED" }],
        sponsoringMinistry:
          (groupCategory === "CENTRAL" ||
            groupCategory === "CENTRAL_DEPARTMENT") &&
          summaryType === "SPONSOR"
            ? [
                {
                  key: user.groupId.toString(),
                  displayName: user.groupName
                }
              ]
            : [],
        recipientMinistry:
          (groupCategory === "STATE" ||
            groupCategory === "CENTRAL" ||
            groupCategory === "CENTRAL_DEPARTMENT") &&
          summaryType === "RECIPIENT"
            ? [
                {
                  key: user.groupId.toString(),
                  displayName: user.groupName
                }
              ]
            : summaryType === "RECIPIENT" && groupCategory === "STATE_PMG"
            ? [
                {
                  key: user.childGroupId.toString(),
                  displayName: user.groupName
                }
              ]
            : [],
        sponsoringState:
          summaryType === "SPONSOR" && groupCategory === "STATE"
            ? [
                {
                  key: user.groupId.toString(),
                  displayName: user.groupName
                }
              ]
            : summaryType === "SPONSOR" && groupCategory === "STATE_PMG"
            ? [
                {
                  key: user.childGroupId.toString(),
                  displayName: user.groupName
                }
              ]
            : [],
        projectTags: [{ key: "OPEN", displayName: "OPEN" }],
        projectFlags: [
          { displayName: "PRAGATI", key: "PRAGATI" },
          checkedValue ? { displayName: "MARCH 24", key: "MARCH 24" } : null
        ]
      },
      resolved: {
        groupCategory: getDashBoardOpenProjectGroupCategoryPayload(
          groupCategory,
          summaryType,
          stateAndCentralProjectSelectedBy
        ),
        projectStage: [{ key: "VERIFIED", displayName: "VERIFIED" }],
        projectTags: [{ key: "RESOLVED", displayName: "RESOLVED" }],
        projectFlags: [
          { displayName: "PRAGATI", key: "PRAGATI" },
          checkedValue ? { displayName: "MARCH 24", key: "MARCH 24" } : null
        ],
        sponsoringMinistry:
          (groupCategory === "CENTRAL" ||
            groupCategory === "CENTRAL_DEPARTMENT") &&
          summaryType === "SPONSOR"
            ? [
                {
                  key: user.groupId.toString(),
                  displayName: user.groupName
                }
              ]
            : [],
        recipientMinistry:
          (groupCategory === "STATE" ||
            groupCategory === "CENTRAL" ||
            groupCategory === "CENTRAL_DEPARTMENT") &&
          summaryType === "RECIPIENT"
            ? [
                {
                  key: user.groupId.toString(),
                  displayName: user.groupName
                }
              ]
            : summaryType === "RECIPIENT" && groupCategory === "STATE_PMG"
            ? [
                {
                  key: user.childGroupId.toString(),
                  displayName: user.groupName
                }
              ]
            : [],
        sponsoringState:
          summaryType === "SPONSOR" && groupCategory === "STATE"
            ? [
                {
                  key: user.groupId.toString(),
                  displayName: user.groupName
                }
              ]
            : summaryType === "SPONSOR" && groupCategory === "STATE_PMG"
            ? [
                {
                  key: user.childGroupId.toString(),
                  displayName: user.groupName
                }
              ]
            : []
      },
      noIssues: {
        groupCategory: getDashBoardOpenProjectGroupCategoryPayload(
          groupCategory,
          summaryType,
          stateAndCentralProjectSelectedBy
        ),
        projectStage: [{ key: "VERIFIED", displayName: "VERIFIED" }],
        projectTags: [
          { key: "NO_ISSUES_OR_ALL_REJECTED", displayName: "NO ISSUES" }
        ],
        projectFlags: [
          { displayName: "PRAGATI", key: "PRAGATI" },
          checkedValue ? { displayName: "MARCH 24", key: "MARCH 24" } : null
        ],
        sponsoringMinistry:
          (groupCategory === "CENTRAL" ||
            groupCategory === "CENTRAL_DEPARTMENT") &&
          summaryType === "SPONSOR"
            ? [
                {
                  key: user.groupId.toString(),
                  displayName: user.groupName
                }
              ]
            : [],
        recipientMinistry:
          (groupCategory === "STATE" ||
            groupCategory === "CENTRAL" ||
            groupCategory === "CENTRAL_DEPARTMENT") &&
          summaryType === "RECIPIENT"
            ? [
                {
                  key: user.groupId.toString(),
                  displayName: user.groupName
                }
              ]
            : summaryType === "RECIPIENT" && groupCategory === "STATE_PMG"
            ? [
                {
                  key: user.childGroupId.toString(),
                  displayName: user.groupName
                }
              ]
            : [],
        sponsoringState:
          summaryType === "SPONSOR" && groupCategory === "STATE"
            ? [
                {
                  key: user.groupId.toString(),
                  displayName: user.groupName
                }
              ]
            : summaryType === "SPONSOR" && groupCategory === "STATE_PMG"
            ? [
                {
                  key: user.childGroupId.toString(),
                  displayName: user.groupName
                }
              ]
            : []
      }
    },
    summary_issue: {
      verified: {
        groupCategory: getDashBoardOpenProjectGroupCategoryPayload(
          groupCategory,
          summaryType,
          stateAndCentralProjectSelectedBy
        ),
        projectFlags: [
          checkedValue ? { displayName: "MARCH 24", key: "MARCH 24" } : null
        ],
        projectStage: [{ key: "VERIFIED", displayName: "VERIFIED" }],
        sponsoringMinistry:
          (groupCategory === "CENTRAL" ||
            groupCategory === "CENTRAL_DEPARTMENT") &&
          summaryType === "SPONSOR"
            ? [
                {
                  key: user.groupId.toString(),
                  displayName: user.groupName
                }
              ]
            : [],
        recipientState:
          (groupCategory === "CENTRAL" ||
            groupCategory === "STATE" ||
            groupCategory === "CENTRAL_DEPARTMENT") &&
          summaryType === "RECIPIENT"
            ? [
                {
                  key: user.groupId.toString(),
                  displayName: user.groupName
                }
              ]
            : summaryType === "RECIPIENT" && groupCategory === "STATE_PMG"
            ? [
                {
                  key: user.childGroupId.toString(),
                  displayName: user.groupName
                }
              ]
            : [],
        sponsoringState:
          summaryType === "SPONSOR" && groupCategory === "STATE"
            ? [
                {
                  key: user.groupId.toString(),
                  displayName: user.groupName
                }
              ]
            : summaryType === "SPONSOR" && groupCategory === "STATE_PMG"
            ? [
                {
                  key: user.childGroupId.toString(),
                  displayName: user.groupName
                }
              ]
            : [],
        stages:
          groupCategory === "PMG"
            ? [
                {
                  key: "955",
                  displayName: "Pending with PMG"
                },
                {
                  key: "963",
                  displayName: "Pending with RM/RS"
                },
                {
                  key: "968",
                  displayName: "Under PMG Decision"
                }
              ]
            : ((groupCategory === "STATE_PMG" ||
                groupCategory === "STATE" ||
                isStateAndDistrictUser) &&
                summaryType === "SPONSOR") ||
              (isStateAndDistrictUser &&
                stateAndCentralProjectSelectedBy === "STATE" &&
                groupCategory !== "STATE_DEPARTMENT")
            ? [
                {
                  key: "979",
                  displayName: "Pending with State PMG"
                },

                {
                  key: "980",
                  displayName: "Pending with RD"
                },
                {
                  key: "981",
                  displayName: "Under State PMG Decision"
                }
              ]
            : ((groupCategory === "CENTRAL" ||
                groupCategory === "CENTRAL_DEPARTMENT" ||
                groupCategory === "OTHER" ||
                isStateAndDistrictUser) &&
                (summaryType === "SPONSOR" ||
                  summaryType === "RECIPIENT" ||
                  summaryType === null) &&
                groupCategory !== "STATE_DEPARTMENT") ||
              (isStateAndDistrictUser &&
                stateAndCentralProjectSelectedBy === "CENTRAL")
            ? [
                {
                  key: "955",
                  displayName: "Pending with PMG"
                },
                {
                  key: "968",
                  displayName: "Under PMG Decision"
                },
                {
                  key: "963",
                  displayName: "Pending with RM/RS"
                }
              ]
            : (groupCategory === "STATE_PMG" ||
                groupCategory === "STATE" ||
                groupCategory === "PP") &&
              !isStateAndDistrictUser &&
              (summaryType === "CENTRAL" || summaryType === null) &&
              stateAndCentralProjectSelectedBy === "CENTRAL"
            ? [
                {
                  key: "963",
                  displayName: "Pending with RM/RS"
                },
                {
                  key: "968",
                  displayName: "Under PMG Decision"
                },
                {
                  key: "955",
                  displayName: "Pending with PMG"
                }
              ]
            : [
                {
                  key: "963",
                  displayName: "Pending with RM/RS"
                },
                {
                  key: "981",
                  displayName: "Under State PMG Decision"
                },
                {
                  key: "979",
                  displayName: "Pending with State PMG"
                },
                {
                  key: "982",
                  displayName: "Under Central PMG"
                },
                {
                  key: "980",
                  displayName: "Pending with RD"
                },
                {
                  key: "968",
                  displayName: "Under PMG Decision"
                }
              ]
      },

      resolved: {
        groupCategory: getDashBoardOpenProjectGroupCategoryPayload(
          groupCategory,
          summaryType,
          stateAndCentralProjectSelectedBy
        ),
        projectFlags: [
          checkedValue ? { displayName: "MARCH 24", key: "MARCH 24" } : null
        ],
        projectStage: [{ key: "VERIFIED", displayName: "VERIFIED" }],
        stages: [{ key: "974", displayName: "RESOLVED" }],
        sponsoringMinistry:
          (groupCategory === "CENTRAL" ||
            groupCategory === "CENTRAL_DEPARTMENT") &&
          summaryType === "SPONSOR"
            ? [
                {
                  key: user.groupId.toString(),
                  displayName: user.groupName
                }
              ]
            : [],
        recipientState:
          (groupCategory === "CENTRAL" ||
            groupCategory === "STATE" ||
            groupCategory === "CENTRAL_DEPARTMENT") &&
          summaryType === "RECIPIENT"
            ? [
                {
                  key: user.groupId.toString(),
                  displayName: user.groupName
                }
              ]
            : summaryType === "RECIPIENT" && groupCategory === "STATE_PMG"
            ? [
                {
                  key: user.childGroupId.toString(),
                  displayName: user.groupName
                }
              ]
            : [],
        sponsoringState:
          summaryType === "SPONSOR" && groupCategory === "STATE"
            ? [
                {
                  key: user.groupId.toString(),
                  displayName: user.groupName
                }
              ]
            : summaryType === "SPONSOR" && groupCategory === "STATE_PMG"
            ? [
                {
                  key: user.childGroupId.toString(),
                  displayName: user.groupName
                }
              ]
            : []
      }
    }
  };

  return sections[type] || {};
};

export const FILTERS_ACTIONS = {
  _PROJECT_LIST_: {
    _START: "_PROJECT_LIST_START",
    _SUCCESS: "_PROJECT_LIST_SUCCESS",
    _FAILURE: "_PROJECT_LIST_FAILURE",
    _CLEAR: "_PROJECT_LIST_CLEAR"
  },
  _ISSUE_LIST_: {
    _START: "_ISSUE_LIST_START",
    _SUCCESS: "_ISSUE_LIST_SUCCESS",
    _FAILURE: "_ISSUE_LIST_FAILURE",
    _CLEAR: "_ISSUE_LIST_CLEAR"
  }
};

export const SORT_BY_FILTERS_LIST = [
  {
    sortBy: "PROJECT_COST",
    sortOrder: "DESC",
    name: (
      <span>
        by <b>High</b> budget
      </span>
    ),
    active: "high"
  },
  {
    sortBy: "PROJECT_COST",
    sortOrder: "ASC",
    name: (
      <span>
        by <b>Low</b> budget
      </span>
    ),
    active: "low"
  },
  {
    sortBy: "CREATED_DATE",
    sortOrder: "DESC",
    name: (
      <span>
        by <b>Latest</b> created
      </span>
    ),
    active: "latest"
  },
  {
    sortBy: "CREATED_DATE",
    sortOrder: "ASC",
    name: (
      <span>
        by <b>Old</b> created
      </span>
    ),
    active: "old"
  },
  {
    sortBy: "VERIFICATION_DATE",
    sortOrder: "DESC",
    name: (
      <span>
        by <b>Latest</b> verified
      </span>
    ),
    active: "latest"
  },
  {
    sortBy: "VERIFICATION_DATE",
    sortOrder: "ASC",
    name: (
      <span>
        by <b>Old</b> verified
      </span>
    ),
    active: "old"
  }
];

export const PENDING_ISSUE_WITH_RECIPIENT = [
  { key: "", value: "", displayName: "All" },
  {
    key: "977",
    value: "HOLD",
    displayName: "On Hold",
    count: 195,
    checked: false
  },
  {
    key: "955",
    value: "UNDER_CONSIDERATION",
    displayName: "Pending with PMG",
    count: 40,
    checked: false
  },
  {
    key: "963",
    value: "UNDER_PROCESS",
    displayName: "Pending with RM/RS",
    count: 694,
    checked: false
  },
  {
    key: "954",
    value: "UNDER_VERIFICATION",
    displayName: "Pending with SM",
    count: 119,
    checked: false
  },
  {
    key: "968",
    value: "UNDER_DECISION",
    displayName: "Under PMG Decision",
    count: 119,
    checked: false
  },
  {
    key: "958",
    value: "REJECT",
    displayName: "Rejected",
    count: 292,
    checked: false
  },
  {
    key: "974",
    value: "RESOLVED",
    displayName: "RESOLVED",
    count: 3606,
    checked: false
  }
];

export const ISSUE_STAGES_CENTRAL = [
  {
    key: "963",
    displayName: "Pending with RM/RS"
  },
  {
    key: "955",
    displayName: "Pending with PMG"
  },
  {
    key: "968",
    displayName: "Under PMG Decision"
  }
];

export const ISSUE_STAGES_STATE = [
  {
    key: "980",
    displayName: "Pending with RD"
  },
  {
    key: "979",
    displayName: "Pending with State PMG"
  },
  {
    key: "981",
    displayName: "Under State PMG Decision"
  },
  {
    key: "963",
    displayName: "Pending with RM/RS"
  },
  {
    key: "982",
    displayName: "Under Central PMG Decision"
  },
  {
    key: "968",
    displayName: "Under PMG Decision"
  }
];

export const PRAGATI_ISSUE_WITH_RECIPIENT = [
  { key: "", value: "", displayName: "All" },
  {
    key: "UNDER_VERIFICATION",
    value: "UNDER_VERIFICATION",
    displayName: "Under Verification",
    count: 195,
    checked: false
  },
  {
    key: "VERIFIED",
    value: "VERIFIED",
    displayName: "VERIFIED",
    count: 195,
    checked: false
  },
  {
    key: "ON_HOLD",
    value: "ON_HOLD",
    displayName: "On Hold",
    count: 195,
    checked: false
  },
  {
    key: "REJECTED",
    value: "REJECTED",
    displayName: "REJECTED",
    count: 195,
    checked: false
  },
  {
    key: "TERMINATED",
    value: "TERMINATED",
    displayName: "TERMINATED",
    count: 195,
    checked: false
  }
];

export const PROJECTS_BY = [
  { key: "", value: "", displayName: "All" },
  {
    key: "UNDER_VERIFICATION",
    value: "UNDER_VERIFICATION",
    displayName: "Under Verification",
    count: 195,
    checked: false
  },
  {
    key: "VERIFIED",
    value: "VERIFIED",
    displayName: "VERIFIED",
    count: 195,
    checked: false
  },
  {
    key: "ON_HOLD",
    value: "ON_HOLD",
    displayName: "On Hold",
    count: 195,
    checked: false
  },
  {
    key: "REJECTED",
    value: "REJECTED",
    displayName: "REJECTED",
    count: 195,
    checked: false
  }
];

export const SORT_BY_ISSUE_FILTER_LIST = [
  {
    sortBy: "PROJECT_COST",
    sortOrder: "DESC",
    name: (
      <span>
        by <b>High</b> budget
      </span>
    ),
    active: "high"
  },
  {
    sortBy: "PROJECT_COST",
    sortOrder: "ASC",
    name: (
      <span>
        by <b>Low</b> budget
      </span>
    ),
    active: "low"
  },
  {
    sortBy: "CREATED_DATE",
    sortOrder: "DESC",
    name: (
      <span>
        by <b>Latest</b> created
      </span>
    ),
    active: "latest"
  },
  {
    sortBy: "CREATED_DATE",
    sortOrder: "ASC",
    name: (
      <span>
        by <b>Old</b> created
      </span>
    ),
    active: "old"
  },
  {
    sortBy: "VERIFICATION_DATE",
    sortOrder: "DESC",
    name: (
      <span>
        by <b>Latest</b> verified
      </span>
    ),
    active: "latest"
  },
  {
    sortBy: "VERIFICATION_DATE",
    sortOrder: "ASC",
    name: (
      <span>
        by <b>Old</b> verified
      </span>
    ),
    active: "old"
  }
];

export const MIGRATE_PROJECT_ACTION = {
  MIGRATE: {
    _START: "MIGRATE_START",
    _SUCCESS: "MIGRATE_SUCCESS",
    _FAILURE: "MIGRATE_FAILURE",
    _CLEAR: "MIGRATE_CLEAR",
    _UPDATE: "MIGRATE_UPDATE"
  },
  PROJECT_LIST: {
    _START: "PROJECT_LIST_START",
    _SUCCESS: "PROJECT_LIST_SUCCESS",
    _FAILURE: "PROJECT_LIST_FAILURE"
  }
};

export const USER_MANUAL_ACTION = {
  _START: "USER_MANUAL_ACTION_START",
  _SUCCESS: "USER_MANUAL_ACTION_SUCCESS",
  _FAILURE: "USER_MANUAL_ACTION_FAILURE"
};

export const GET_LATEST_NEWS_ACTION = {
  GET_LATEST_NEWS_START: "GET_LATEST_NEWS_START",
  GET_LATEST_NEWS_SUCCESS: "GET_LATEST_NEWS_SUCCESS",
  GET_LATEST_NEWS_FAILURE: "GET_LATEST_NEWS_FAILURE"
};

export const GET_BLOGS_ACTION = {
  GET_BLOGS_START: "GET_BLOGS_START",
  GET_BLOGS_SUCCESS: "GET_BLOGS_SUCCESS",
  GET_BLOGS_FAILURE: "GET_BLOGS_FAILURE"
};

export const PDF_CONSTANT = {
  FIRST_PAGE: {
    FIRST: {
      _SUCCESS: "FIRST_PAGE_FIRST_CHART_SUCCESS",
      _FAILURE: "FIRST_PAGE_FIRST_CHART_FAILURE"
    },
    SECOND: {
      _SUCCESS: "FIRST_PAGE_SECOND_CHART_SUCCESS",
      _FAILURE: "FIRST_PAGE_SECOND_CHART_FAILURE"
    },
    THIRD: {
      _SUCCESS: "FIRST_PAGE_THIRD_CHART_SUCCESS",
      _FAILURE: "FIRST_PAGE_THIRD_CHART_FAILURE"
    },
    FOURTH: {
      _SUCCESS: "FIRST_PAGE_FOURTH_CHART_SUCCESS",
      _FAILURE: "FIRST_PAGE_FOURTH_CHART_FAILURE"
    }
  },
  SECOND_PAGE: {
    FIRST: {
      _SUCCESS: "SECOND_PAGE_FIRST_CHART_SUCCESS",
      _FAILURE: "SECOND_PAGE_FIRST_CHART_FAILURE"
    },
    SECOND: {
      _SUCCESS: "SECOND_PAGE_SECOND_CHART_SUCCESS",
      _FAILURE: "SECOND_PAGE_SECOND_CHART_FAILURE"
    },
    THIRD: {
      _SUCCESS: "SECOND_PAGE_THIRD_CHART_SUCCESS",
      _FAILURE: "SECOND_PAGE_THIRD_CHART_FAILURE"
    },
    FOURTH: {
      _SUCCESS: "SECOND_PAGE_FOURTH_CHART_SUCCESS",
      _FAILURE: "SECOND_PAGE_FOURTH_CHART_FAILURE"
    },
    FIFTH: {
      _SUCCESS: "SECOND_PAGE_FIFTH_CHART_SUCCESS",
      _FAILURE: "SECOND_PAGE_FIFTH_CHART_FAILURE"
    }
  },
  LAST_PAGE: {
    FIRST: {
      _SUCCESS: "LAST_PAGE_FIRST_CHART_SUCCESS",
      _FAILURE: "LAST_PAGE_FIRST_CHART_FAILURE"
    },
    SECOND: {
      _SUCCESS: "LAST_PAGE_SECOND_CHART_SUCCESS",
      _FAILURE: "LAST_PAGE_SECOND_CHART_FAILURE"
    },
    THIRD: {
      _SUCCESS: "LAST_PAGE_THIRD_CHART_SUCCESS",
      _FAILURE: "LAST_PAGE_THIRD_CHART_FAILURE"
    },
    FOURTH: {
      _SUCCESS: "LAST_PAGE_FOURTH_CHART_SUCCESS",
      _FAILURE: "LAST_PAGE_FOURTH_CHART_FAILURE"
    },
    FIFTH: {
      _SUCCESS: "LAST_PAGE_FIFTH_CHART_SUCCESS",
      _FAILURE: "LAST_PAGE_FIFTH_CHART_FAILURE"
    },
    SIXTH: {
      _SUCCESS: "LAST_PAGE_SIXTH_CHART_SUCCESS",
      _FAILURE: "LAST_PAGE_SIXTH_CHART_FAILURE"
    }
  }
};

export const PROJECT_AWARDED_BY = {
  STATE: "STATE",
  CENTRAL: "CENTRAL"
};

export const DASHBOARD_CALENDER = [
  {
    title: "All",
    value: "All"
  },
  {
    title: "Current Month",
    value: "currentMonth"
  },
  // {
  //   title: "Last 6 Months",
  //   value: "180"
  // },
  {
    title: "This Year",
    value: "365"
  },
  {
    title: "Select Date Range"
  },
  {
    title: "Since PMG Merger",
    value: "PMG Merger"
  },
  {
    title: "Since Inception",
    value: "Since Inception"
  }
];

export const OTHER_CALENDER = [
  {
    title: "All",
    value: "All"
  },
  {
    title: "This Month",
    value: "This Month"
  },
  {
    title: "Last 6 Months",
    value: "180"
  },
  {
    title: "This Year",
    value: "365"
  },
  {
    title: "Since Inception",
    value: "Since Inception"
  },
  {
    title: "Select Date Range"
  }
];

export const MEETING_OPTION = {
  IN_PERSON: "In-person",
  VIDEO_CONFERENCE: "Video conference"
};

export const ADD_DECISION = {
  WITH_AGENDA: "WITH AGENDA",
  WITHOUT_AGENDA: "WITHOUT AGENDA"
};

export const ISSUE_DECISION_DETAILS = {
  MOM_HEADER_TITLE: "Decision(s)"
};

export const GROUP_CATEGORY = {
  PP: "Project Proponent",
  PMG: "PMG",
  STATE_PMG: "State PMG",
  STATE: "State",
  STATE_DEPARTMENT: "State Department",
  DISTRICT: "District",
  CENTRAL: "Central Ministry",
  CENTRAL_DEPARTMENT: "Central Department",
  INDUSTRIAL: "Industrial",
  OTHER: "Other",
  NA: "NA"
};

export const DROP_DOWN_VALUES = [
  { title: "With issue status", value: "with-issue-status" },
  { title: "Without issue status", value: "without-issue-status" },
  // { title: "CabSec format", value: "cabsec-format" },
  //{ title: "Old format", value: "old-format" },
  { title: "Monitoring Group", value: "monitoring-group" },
  { title: "PRAGATI Format", value: "pragati-format" }
];

export const GROUP_ROLE = {
  CENTRAL_NODAL_OFFICER: 14,
  STATE_NODAL_OFFICER: 15,
  STATE_DEPARTMENT_NODAL_OFFICER: 16,
  CENTRAL_DEPARTMENT_NODAL_OFFICER: 17
};
export const PROJECT_CLASSIFICATION = [
  {
    name: "projectClassification",
    label: "Brown Field",
    value: "BROWN_FIELD",
    optionName: "projectClassification"
  },
  {
    name: "projectClassifiaction",
    label: "Green Field",
    value: "GREEN_FIELD",
    optionName: "projectClassification"
  }
];

export const MULTI_STATE_PROJECT = [
  {
    name: "multiStateProject",
    label: "Yes",
    value: "Yes",
    optionName: "multiStateProject"
  },
  {
    name: "multiStateProject",
    label: "No",
    value: "No",
    optionName: "multiStateProject"
  }
];
export const SELECT_MONITORING_OPTION = [
  {
    name: "monitoring",
    label: "All Issues Not Resolved",
    value: "Active",
    optionName: "monitoring"
  },
  {
    name: "monitoring",
    label: "All Issues Resolved",
    value: "Passive",
    optionName: "monitoring"
  }
];

export const AGENDA_FLAT_FILE = [
  {
    name: "agendaFlatFile",
    label: "Agendas",
    value: "AGENDA",
    isAgenda: true,
    optionName: "agendaFlatFile"
  },
  {
    name: "agendaFlatFile",
    label: "Issues",
    value: "ISSUES",
    isIssues: true,
    optionName: "agendaFlatFile"
  },
  {
    name: "agendaFlatFile",
    label: "Projects",
    value: "PROJECTS",
    isProjects: true,
    optionName: "agendaFlatFile"
  }
];

export const FILE_FORMAT_IMG = [".png, .jpg, .jpeg"];

export const PMG_CONSTANTS = {
  PMG_FORM_START: "PMG_FORM_START",
  PMG_FORM_SUCCESS: "PMG_FORM_SUCCESS",
  PMG_FORM_FAILURE: "PMG_FORM_FAILURE",
  PMG_FORM_GET_START: "PMG_FORM_GET_START",
  PMG_FORM_GET_SUCCESS: "PMG_FORM_GET_SUCCESS",
  PMG_FORM_GET_FAILURE: "PMG_FORM_GET_FAILURE",
  PMG_FORM_UPDATE_START: "PMG_FORM_UPDATE_START",
  PMG_FORM_UPDATE_SUCCESS: "PMG_FORM_UPDATE_SUCCESS",
  PMG_FORM_UPDATE_FAILURE: "PMG_FORM_UPDATE_FAILURE",
  PMG_UPDATE_ADD_START: "PMG_UPDATE_ADD_START",
  PMG_UPDATE_ADD_SUCCESS: "PMG_UPDATE_ADD_SUCCESS",
  PMG_UPDATE_ADD_FAILURE: "PMG_UPDATE_ADD_FAILURE",
  PMG_UPDATE_GET_START: "PMG_UPDATE_GET_START",
  PMG_UPDATE_GET_SUCCESS: "PMG_UPDATE_GET_SUCCESS",
  PMG_UPDATE_GET_FAILURE: "PMG_UPDATE_GET_FAILURE",
  PMG_UPDATE_EDIT_START: "PMG_UPDATE_EDIT_START",
  PMG_UPDATE_EDIT_SUCCESS: "PMG_UPDATE_EDIT_SUCCESS",
  PMG_UPDATE_EDIT_FAILURE: "PMG_UPDATE_EDIT_FAILURE",
  PMG_HEADING_START: "PMG_HEADING_START",
  PMG_HEADING_SUCCESS: "PMG_HEADING_SUCCESS",
  PMG_HEADING_FAILURE: "PMG_HEADING_FAILURE",
  PMG_HEADING_GET_START: "PMG_HEADING_GET_START",
  PMG_HEADING_GET_SUCCESS: "PMG_HEADING_GET_SUCCESS",
  PMG_HEADING_GET_FAILURE: "PMG_HEADING_GET_FAILURE",
  PMG_HEADING_UPDATE_START: "PMG_HEADING_UPDATE_START",
  PMG_HEADING_UPDATE_SUCCESS: "PMG_HEADING_UPDATE_SUCCESS",
  PMG_HEADING_UPDATE_FAILURE: "PMG_HEADING_UPDATE_FAILURE",
  DPIIT_START: "DPIIT_START",
  DPIIT_SUCCESS: "DPIIT_SUCCESS",
  DPIIT_FAILURE: "DPIIT_FAILURE",
  DPIIT_GET_START: "DPIIT_GET_START",
  DPIIT_GET_SUCCESS: "DPIIT_GET_SUCCESS",
  DPIIT_GET_FAILURE: "DPIIT_GET_FAILURE",
  DPIIT_UPDATE_START: "DPIIT_UPDATE_START",
  DPIIT_UPDATE_SUCCESS: "DPIIT_UPDATE_SUCCESS",
  DPIIT_UPDATE_FAILURE: "DPIIT_UPDATE_FAILURE",
  SECTION_START: "SECTION_START",
  SECTION_SUCCESS: "SECTION_SUCCESS",
  SECTION_FAILURE: "SECTION_FAILURE",
  SECTION_GET_START: "SECTION_GET_START",
  SECTION_GET_SUCCESS: "SECTION_GET_SUCCESS",
  SECTION_GET_FAILURE: "SECTION_GET_FAILURE",
  SECTION_UPDATE_START: "SECTION_UPDATE_START",
  SECTION_UPDATE_SUCCESS: "SECTION_UPDATE_SUCCESS",
  SECTION_UPDATE_FAILURE: "SECTION_UPDATE_FAILURE",

  DPIIT_GET_START_LANDINGPAGE: "DPIIT_GET_START_LANDINGPAGE",
  DPIIT_GET_SUCCESS_LANDINGPAGE: "DPIIT_GET_SUCCESS_LANDINGPAGE",
  DPIIT_GET_FAILURE_LANDINGPAGE: "DPIIT_GET_FAILURE_LANDINGPAGE",
  PMG_GET_START_LANDINGPAGE: "PMG_GET_START_LANDINGPAGE",
  PMG_GET_SUCCESS_LANDINGPAGE: "PMG_GET_SUCCESS_LANDINGPAGE",
  PMG_GET_FAILURE_LANDINGPAGE: "PMG_GET_FAILURE_LANDINGPAGE",
  SECTION_GET_START_LANDINGPAGE: "SECTION_GET_START_LANDINGPAGE",
  SECTION_GET_SUCCESS_LANDINGPAGE: "SECTION_GET_SUCCESS_LANDINGPAGE",
  SECTION_GET_FAILURE_LANDINGPAGE: "SECTION_GET_FAILURE_LANDINGPAGE",
  UPDATE_GET_START_LANDINGPAGE: "UPDATE_GET_START_LANDINGPAGE",
  UPDATE_GET_SUCCESS_LANDINGPAGE: "UPDATE_GET_SUCCESS_LANDINGPAGE",
  UPDATE_GET_FAILURE_LANDINGPAGE: "UPDATE_GET_FAILURE_LANDINGPAGE",
  HEADING_GET_START_LANDINGPAGE: "HEADING_GET_START_LANDINGPAGE",
  HEADING_GET_SUCCESS_LANDINGPAGE: "HEADING_GET_SUCCESS_LANDINGPAGE",
  HEADING_GET_FAILURE_LANDINGPAGE: "HEADING_GET_FAILURE_LANDINGPAGE",

  HEADING_DETAILS_SUCCESS: "HEADING_DETAILS_SUCCESS",
  HEADING_SELECTED_TAB: "HEADING_SELECTED_TAB",

  DPIIT_SORT_START: "DPIIT_SORT_START",
  DPIIT_SORT_SUCCESS: "DPIIT_SORT_SUCCESS",
  DPIIT_SORT_FAILURE: "DPIIT_SORT_FAILURE",
  INVEST_SORT_START: "INVEST_SORT_START",
  INVEST_SORT_SUCCESS: "INVEST_SORT_SUCCESS",
  INVEST_SORT_FAILURE: "INVEST_SORT_FAILURE",
  SECTION_SORT_START: "SECTION_SORT_START",
  SECTION_SORT_SUCCESS: "SECTION_SORT_SUCCESS",
  SECTION_SORT_FAILURE: "SECTION_SORT_FAILURE",
  DPIIT_SORT_GET_START: "DPIIT_SORT_GET_START",
  DPIIT_SORT_GET_SUCCESS: "DPIIT_SORT_GET_SUCCESS",
  DPIIT_SORT_GET_FAILURE: "DPIIT_SORT_GET_FAILURE",
  INVEST_SORT_GET_START: "INVEST_SORT_GET_START",
  INVEST_SORT_GET_SUCCESS: "INVEST_SORT_GET_SUCCESS",
  INVEST_SORT_GET_FAILURE: "INVEST_SORT_GET_FAILURE",
  SECTION_SORT_GET_START: "SECTION_SORT_GET_START",
  SECTION_SORT_GET_SUCCESS: "SECTION_SORT_GET_SUCCESS",
  SECTION_SORT_GET_FAILURE: "SECTION_SORT_GET_FAILURE",
  PMG_LIST_DATA_SUCCESS: "PMG_LIST_DATA_SUCCESS",
  UNDER_MAINTENANCE_SUCCESS: "UNDER_MAINTENANCE_SUCCESS"
};

export const PRAGATI_ACTION = {
  GET_UPCOMMING_AGENDA_FLAG_START: "GET_UPCOMMING_AGENDA_FLAG_START",
  GET_UPCOMMING_AGENDA_FLAG_SUCCESS: "GET_UPCOMMING_AGENDA_FLAG_SUCCESS",
  GET_UPCOMMING_AGENDA_FLAG_FAILURE: "GET_UPCOMMING_AGENDA_FLAG_FAILURE"
};

export const PARIVESH_MAPPING_FC = [
  // { key: "proposalNo", label: "Proposal Number" },
  { key: "projectName", label: "Project Name" },
  { key: "dateOfSubmission", label: "Date of submission of proposal" },
  { key: "projectCategory", label: "Project Category" },
  { key: "state", label: "State" },
  { key: "district", label: "District(s)" },
  { key: "districtWiseArea", label: "Total Area (Ha.)" },
  { key: "regionalOffice", label: "Regional Office" },
  { key: "currentStatus", label: "Current status" },
  { key: "inPrincipalApprovalStatus", label: "In Principal Approval" },
  { key: "approvalDate", label: "Stage- I date" },
  { key: "finalApprovalDate", label: "Stage- II date" },
  { key: "edsQueryHistoryUrl", label: "EDS History" }
];

export const PARIVESH_MAPPING_WLC = [
  // { key: "proposalNumber", label: "Proposal Number" },
  { key: "projectName", label: "Project Name" },
  { key: "dateOfSubmission", label: "Date of submission of proposal" },
  { key: "projectCategory", label: "Project Category" },
  { key: "state", label: "State" },
  { key: "district", label: "District(s)" },
  { key: "districtWiseArea", label: "Total Area (Ha.)" },
  { key: "currentStatus", label: "Current Status" },
  { key: "finalApprovalDate", label: "Clearance Date" }
];

export const PARIVESH_MAPPING_EC_CRZ = [
  // { key: "proposalNumber", label: "Proposal Number" },
  { key: "projectName", label: "Project Name" },
  { key: "dateOfSubmission", label: "Date of submission of proposal" },
  { key: "projectCategory", label: "Activity" },
  { key: "state", label: "State" },
  { key: "district", label: "District(s)" },
  { key: "districtWiseArea", label: "Total Area (Ha.)" },
  { key: "currentStatus", label: "Current status" },
  { key: "finalApprovalDate", label: "Clearance Date" }
];

export const archiveDropdown = [
  { key: "ALL", label: "All Projects", image: allIcon },
  { key: "ACTIVE", label: "Active Projects", image: activeIcon },
  { key: "ARCHIVED", label: "Archived Projects", image: archiveIcon }
];
